export default [
/*   
  {
    key: '[Runewords]/Armor/Class-Items/Bone(AP)',
    value: {
      base64:
        'EAiABARQFZrZGkfF+7VDRKBYiIfHQHiwZPQ/ge0UyZhCxSOZQsTjPxAAoAA0AOB8mAAQAKAANATgMEwAEACgADQI4DBMAA==',
    },
  },
  {
    key: '[Runewords]/Armor/Class-Items/Enlightenment(AP)',
    value: {
      base64:
        'EAiABARAFZrZyDSv5LRDeKBYiIfHQHiwZPR/ShSmRGDseaGQ7HGh8B8QAKAANADgMJ8AEACgADQE4HwjARAAoAA0COB8mAA=',
    },
  },
  {
    key: '[Runewords]/Armor/Class-Items/Myth(AP)',
    value: {
      base64:
        'EAiABAQQFJrZ9ht+U7RD4KBYiIfHQHiwZPRfCTqFMhYkokgWCDL4DxAAoAA0AOB80AIQAKAANATgfD4BEACgADQI4Hx/BQ==',
    },
  },
  {
    key: '[Runewords]/Armor/Class-Items/Peace(AP)',
    value: {
      base64:
        'EAiABARIFZrZiB4DF7RD9qBYiIfHQHiwZPR/ChQmgWDsAUGQrIiA8B8QAKAANADgfLYBEACgADQE4Hy+AxAAoAA0COB8PgE=',
    },
  },
  {
    key: '[Runewords]/Armor/Class Specific/Principle(AP)',
    value: {
      base64:
        'EAiABAQIFJrZXlcmLrVDDqFYiIfHQHiwZPR/ymSsKIOsx8gBW/8BEACgADQA4HwjARAAoAA0BOAwaAEQAKAANAjgfDMB',
    },
  },
  {
    key: '[Runewords]/Armor/Class-Itemsc/Rain(AP)',
    value: {
      base64:
        'EAiABAQIBJrZPCse67RDHKFYiIfHQHiwZPQ/ge2UytgDTyHZs07hPxAAoAA0AOB8uwAQAKAANATgMNsAEACgADQI4HzvAw==',
    },
  },
  {
    key: '[Runewords]/Armor/Class-Items/Treachery(AP)',
    value: {
      base64:
        'EAiABAQAFJrZfvp8abRDWqFYiIfHQHiwZPR/itUlaOyxKJPsWajwHxAAoAA0AOB8tgEQAKAANATgfL4DEACgADQI4DDfAQ==',
    },
  },
  {
    key: '[Runewords]/Armor/Chains of Honor(CoH)(AP)',
    value: {
      base64:
        'EAiABATMFJoZKfXB07RDUKBYiIcHQXiwZPQfAA0EIyf0pdC3Ql8LfTwQebjpwfNH/wEQAKAANADgfL4CEACgADQE4DBMABAAoAA0COBsvwMQAKAANAzgMF8B',
    },
  },
  {
    key: '[Runewords]/Armor/Duress(AP)',
    value: {
      base64:
        'EAiABAQABJrZsJmv67VDcKBYiIfHQHiwZPQfArIIFCjYKCkkMwZ1KITooQnwHxAAoAA0AOB8tgEQAKAANATgMEwAEACgADQI4Hy+Aw==',
    },
  },
  {
    key: '[Runewords]/Armor/Enigma(AP)',
    value: {
      base64:
        'EAiABMwMAJrZ6G9zurVDdqBYiGfHQHjw4QL/PxDMigNMMIyN4I+4GfCQ/xAAoAA0AOBsPwEQAKAANATgfO8DEACgADQI4Gy/Aw==',
    },
  },
  {
    key: '[Runewords]/Armor/Fortitude(AP)',
    value: {
      base64:
        'EAiABAQYBJoZGyNS2rRDhqBYiIcHQXiwZPQfArIILFmeMJfC3ApzLcylaclhkj08ULAx/wEQAKAANADgfH8CEACgADQE4HyYABAAoAA0COB8vgIQAKAANAzgMEgA',
    },
  },
  {
    key: '[Runewords]/Armor/Wealth(DS)',
    value: {
      base64:
        'EAiABAQABMJfs8HHMdcOyYVCAQoK8/+JVyjI/wEQAKAANADgMN8BEACgADQE4HyQABAAoAA0COB8bwM=',
    },
  },
  {
    key: '[Runewords]/Helmet/Delirium(Corona)',
    value: {
      base64:
        'EAiABAQABB62pa4pwGqHwEChgAyA+f/hIX9kTIpikaxpwpHMiciQTPYqwCyygofnPxAAoAA0AOAw3wEQAKAANATgMF8BEACgADQI4Hz2AQ==',
    },
  },
  {
    key: '[Runewords]/Helmet/Dream(Corona)',
    value: {
      base64:
        'EAiABAQABB62LdMv0GqHFEB5hYyMWTKC8OD/JTtvjOyDObIVJ7il4LaCWwtuUPqSPVEo/gMQAKAANADgfPYBEACgADQE4Gw/ARAAoAA0COAwnwA=',
    },
  },
  {
    key: '[Runewords]/Helmet/Lore(Corona)',
    value: {
      base64:
        'EAiABASQBB427XeTMWuHlEGhgIwM+R9AlcX+RJHgPxAAoAA0AOB8uwAQAKAANATgfJgA',
    },
  },
  {
    key: '[Runewords]/Helmet/Nadir(Corona)',
    value: {
      base64:
        'EAiABASIBB42uT8NF2mHxEGhgIwM+Q+gBIKMDxR4MiRLMGsQSkj4DxAAoAA0AOB8fwUQAKAANATgfG8D',
    },
  },
  {
    key: '[Runewords]/Helmet/Radiance(Corona)',
    value: {
      base64:
        'EAiABASABB62nSbQJGuHNEKhgIyM+R9ANUCVIAjCkhFDlvwPEACgADQA4Hx/BRAAoAA0BOB8mAAQAKAANAjgfO8D',
    },
  },
  {
    key: '[Runewords]/Helmet/Flickering Flame(Diadem)',
    value: {
      base64:
        'EAiABEwEQPy27SPyQU87XAiKESgoDIQHS0b/E6y5MbLTT3aJDGr68B8QAKAANADgfH8FEACgADQE4DCfABAAoAA0COAw+wA=',
    },
  },
  {
    key: '[Runewords]/Helmet/Flickering Flame(Earth)',
    value: {
      base64:
        'EAiABE0EYDxjAwAAABgPF4IiCgoKA+HBktEaeluTb/8TrLkxstNPdokMavrwHxAAoAA1AOB8fwUQAKAANQTgMJ8AEACgADQI4DD7AA==',
    },
  },
  {
    key: '[Runewords]/Merc/Destruction(CA, Eth)',
    value: {
      base64:
        'EAjABAQQ1M9XPVrBDrVDZqAEBakIDx4sGf2P4NUrDTJadQLDLBgexVocyMaucgrGGHou/wEQAKAANADgMPsAEACgADQE4DBIABAAoAA0COBsvwMQAKAANAzgbD8BEACgADQQ4HyQAA==',
    },
  },
  {
    key: '[Runewords]/Merc/Doom(CA, Eth)',
    value: {
      base64:
        'EAjABAQQ1c9X79n157RDaKAEBakIKFA8dfgfASPGLsE6gT+6JIcZk+gpPHX5DxAAoAA0AOB80AIQAKAANATgMD4QAKAANAjgMEwAEACgADQM4DBIABAAoAA0EOBsmQA=',
    },
  },
  {
    key: '[Runewords]/Merc/Infinity(Giant Thresher, Eth)',
    value: {
      base64:
        'EAjABAQAxAMR9/nGS7RDrKBwcKAIDx78j1C0KJjbpT2MGFWDjFm1jofHN8LpzX8QAKAANADgbL8DEACgADQE4DDbABAAoAA0COBsvwMQAKAANAzgMF8B',
    },
  },
  {
    key: '[Runewords]/Merc/Insight(CA, Eth)',
    value: {
      base64:
        'EAjABAQA1M8XTR8U2bRDsKAEBaH/AEoClASUBpQiECQIZS9MAiPN7Y7DS3jifxAAoAA0AOB8IwEQAKAANATgfG8DEACgADQI4Hz7ABAAoAA0DOB8mAA=',
    },
  },
  {
    key: '[Runewords]/Merc/Obedience(CA, Eth)',
    value: {
      base64:
        'EAjABAQIxM9XI8Ni3LRD6qAAVIQHD5aM/keQK/eDTU6YS2FuhbkW5sbwEKGIVTR4mmb8BxAAoAA0AOB80AIQAKAANATgfJAAEACgADQI4Hy+AxAAoAA0DOB8owUQAKAANBDgfFwA',
    },
  },
  {
    key: '[Runewords]/Merc/Phoenix(CA, Eth)',
    value: {
      base64:
        'EAjABAwRwM8X8R3M+7RDAKEEBaEIDx4sGf2PABkyCMiPKpf4NGNWOKhjqAvkphz/ARAAoAA0AOAw+wAQAKAANATgMPsAEACgADQI4DBIABAAoAA0DOBsPwE=',
    },
  },
  {
    key: '[Runewords]/Merc/Pride(CA, Eth)',
    value: {
      base64:
        'EAjABAQIxM8XvQDXH7RDDKEEBaEIDx4sGf2XIWOkxLwD9FIcmiyaIfPumYf8BxAAoAA0AOBsmQAQAKAANATgMC4QAKAANAjgfPYBEACgADQM4DBIAA==',
    },
  },
  {
    key: '[Runewords]/Merc/Rift(CA, Eth)',
    value: {
      base64:
        'EAjABAQYxM8XMXJWObVDJKEEBaEIDx4sGf0HoBJAJUA1QAWDhxYNUH1yzGEVEBBjUD0UZg8TKCj/ARAAoAA0AOB80AIQAKAANATgfJAAEACgADQI4DDfARAAoAA0DOAwaAE=',
    },
  },
  {
    key: '[Runewords]/Shield/Dragon(Monarch)',
    value: {
      base64:
        'EAiABAQIFP5MS50HwtQOqYHiCSsrA+EBhWfJyMzoP4CSACUBpQGlD3IBYe6SGWfs8YGRTLKIwm34DxAAoAA0AOAwLhAAoAA0BOAwSAAQAKAANAjgfJgA',
    },
  },
  {
    key: '[Runewords]/Shield/Dragon(Zaka)',
    value: {
      base64:
        'EAiABATIdL6hMfzNK2mH1EBZRlCQgfAgwoMHFJ4T9VLUW1GvRb0lIzOj/wBKApQElAaUPsgFhLlLZpyxxwdGMskiCrfhPxAAoAA0AOAwLhAAoAA0BOAwSAAQAKAANAjgfJgA',
    },
  },
  {
    key: '[Runewords]/Shield/Dream(Monarch)',
    value: {
      base64:
        'EAiABAQQFf5MY47+OtcOuYHiCSsrA+EBhWfJyMzo/wdznOCWgtsKbi24QekbI7tk5yV7olBkK/4DEACgADQA4Hz2ARAAoAA0BOBsPwEQAKAANAjgMJ8A',
    },
  },
  {
    key: '[Runewords]/Shield/Dream(Zaka)',
    value: {
      base64:
        'EAiABAQQdL6hcXA0JWqH3EBZRlCQgfAgwoMHFJ4T9VLUW1GvRb0lIzOj/x/McYJbCm4ruLXgBqVvjOySnZfsiUKRrfgPEACgADQA4Hz2ARAAoAA0BOBsPwEQAKAANAjgMJ8A',
    },
  },
  {
    key: '[Runewords]/Shield/Exil(Vortex)',
    value: {
      base64:
        'EAiABAQUZD450rixHGiH/EBZh5YWgvAgwoMHFJ4T9VLUW1GvRT0znv8QCJqRGQqX0DheGQAyVkjx4Jf9BxAAoAA0AOAw+wAQAKAANATgMD4QAKAANAjgMF8BEACgADQM4Hy+Ag==',
    },
  },
  {
    key: '[Runewords]/Shield/Phoenix(Monarch)',
    value: {
      base64:
        'EAiABAQIBP5M5NbLQdIOAYTiCSkppKIckIKi/D+GukA2ZoWDusTngYAcATJkmU6PKv8BEACgADQA4DD7ABAAoAA0AOAw+wAQAKAANADgMEgAEACgADQA4Gw/AQ==',
    },
  },
  {
    key: '[Runewords]/Shield/Spirit(Monarch)',
    value: {
      base64:
        'EAiABAQAFf5MDCe4FNUO2YTiCSsrBOEBhWfJyMzo/wBbAkgQ+sYs09z+aBLiPxAAoAA0AOB8+wAQAKAANATgfL4DEACgADQI4Hy7ABAAoAA0DOB8PgE=',
    },
  },
  {
    key: '[Runewords]/Shield/Spirit(Zaka)',
    value: {
      base64:
        'EAiABAQAdL4hQknhw2uHbEJZRlAQgvAgwoMHFJ4T9VLUW1GvRb0lIzOj/wNsCSBB6BuzTHP7o0mI/xAAoAA0AOB8+wAQAKAANATgfL4DEACgADQI4Hy7ABAAoAA0DOB8PgE=',
    },
  },
  {
    key: '[Runewords]/Shield/Splendor(BS)',
    value: {
      base64:
        'EAiABAQghB3klPuzDa8dwgnFExQUBMKDJaM1XbSGiv5DIPPEEhS8LGcGlcbzJ/8BEACgADQA4HyjBRAAoAA0BOB8fAA=',
    },
  },
  {
    key: '[Runewords]/Shield/Splendor(Monarch)',
    value: {
      base64:
        'EAiABAQAFP5MGnYiZ9MO4YTiCSsrAuHBktF/CGSeWIKCl+XMoNJ4/uQ/EACgADQA4HyjBRAAoAA0BOB8fAA=',
    },
  },
  {
    key: '[Runewords]/Shield/Splendor(Zaka)',
    value: {
      base64:
        'EAiABAQYZL4hgQT8E2uHcEJZRlAQgfBgyehEvRT1VtRrUe8/BDJPLEHBy3JmUGk8f/IfEACgADQA4HyjBRAAoAA0BOB8fAA=',
    },
  },
  {
    key: '[Runewords]/Weapon/Axe/Beast(BA)',
    value: {
      base64:
        'EAiABARI1YNXY6Z+2LVDPKBoaKgIDx4sGf0HgBTBocMuvDDghjDkhkt6ErPmnoKC/xAAoAA0AOBsvwMQAKAANATgfG8DEACgADQI4DBMABAAoAA0DOAw2wAQAKAANBDgfHwA',
    },
  },
  {
    key: '[Runewords]/Weapon/Axe/Doom(BA)',
    value: {
      base64:
        'EAiABAQQ1INXHcIsz7RDaKBoaKgIDx78jwAUaJdgncAfXZLDjEn0FJ7y/AcQAKAANADgfNACEACgADQE4DA+EACgADQI4DBMABAAoAA0DOAwSAAQAKAANBDgbJkA',
    },
  },
  {
    key: '[Runewords]/Weapon/Axe/Eternity(BA)',
    value: {
      base64:
        'EAiABAQcxINX5QhAs7RDfKBoaKgIDx78j2DT5gYIJa6lEKaZMkO+wML6DxAAoAA0AOB8PgEQAKAANATgbL8DEACgADQI4DBfARAAoAA0DOB8mAAQAKAANBDgMC4=',
    },
  },
  {
    key: '[Runewords]/Weapon/Bows/Brand(GMB)',
    value: {
      base64:
        'EAiABAQA5FkR+WI3o7VDSKAAUIQHD5aMeAEA6H8EqlSjBOoE8nj1FDAmUUFO5ggx+g8QAKAANADgbD8BEACgADQE4DBIABAAoAA0COAw2wAQAKAANAzgMGgB',
    },
  },
  {
    key: '[Runewords]/Weapon/Bows/Brand(HB)',
    value: {
      base64:
        'EAiABARQdH9BTCkyltAOIYECQBEePFgy+h+BKtUogTqBPF49BYxJVJCTOUKM/gMQAKAANADgbD8BEACgADQE4DBIABAAoAA0COAw2wAQAKAANAzgMGgB',
    },
  },
  {
    key: '[Runewords]/Weapon/Bows/Edge(GMB)',
    value: {
      base64:
        'EAiABAQY5FnRZCdDTrVDcqAATIQHD5aMeAEA6D8AlQAqAaoBqiuPLrc6gTyQ9bC8dOb9BxAAoAA0AOB8bwMQAKAANATgfPsAEACgADQI4Hw+AQ==',
    },
  },
  {
    key: '[Runewords]/Weapon/Bows/Edge(HB)',
    value: {
      base64:
        'EAiABAQgZH9BK2EIFNQOyYECMBEePFgy+g9AJYBKgGqA6sqjy61OIA9kPSwvnXn/ARAAoAA0AOB8bwMQAKAANATgfPsAEACgADQI4Hw+AQ==',
    },
  },
  {
    key: '[Runewords]/Weapon/Bows/Faith(GMB)',
    value: {
      base64:
        'EAiABAUU5FkRAQAAAFICEJSbGxThwQNeAAD7HwEjxhPXUlxbca3FNRh4eO4A/aNLet6mABT/ARAAoAA0AOAwPhAAoAA0BOBsPwEQAKAANAjgMN8BEACgADQM4HwzAQ==',
    },
  },
  {
    key: '[Runewords]/Weapon/Bows/Faith(HB)',
    value: {
      base64:
        'EAiABAQAdH9BdBUyQtcOAYICQBEePFgy+h8BI8YT11JcW3GtxbU7QP/okp63KQDFfxAAoAA0AOAwPhAAoAA0BOBsPwEQAKAANAjgMN8BEACgADQM4HwzAQ==',
    },
  },
  {
    key: '[Runewords]/Weapon/Bows/Harmony(GMB)',
    value: {
      base64:
        'EAiABAQA9VkR713AFbVDlqAAUIQHD5aMeAEA6H+EiRM3UMC4ASXjBsXGDSijLBYGhHFpjmJGfZGR8R8QAKAANADgfG8DEACgADQE4HzvAxAAoAA0COB8mAAQAKAANAzgfJAA',
    },
  },
  {
    key: '[Runewords]/Weapon/Bows/Harmony(HB)',
    value: {
      base64:
        'EAiABAQIdH9B1M+wf9AOWYICQBEePFgy+h9h4sQNFDBuQMm4QbFxAyoqi4UBYVyao5hRX2Rk/AcQAKAANADgfG8DEACgADQE4HzvAxAAoAA0COB8mAAQAKAANAzgfJAA',
    },
  },
  {
    key: '[Runewords]/Weapon/Bows/Ice(GMB)',
    value: {
      base64:
        'EAiABAQI9VkRKRb5D7RDqqAAUIQHD5aMeAEA6H8EadIuyZHGLBYyx9AdyO+ypVCeUvwHEACgADQA4Hw+ARAAoAA0BOB8tgEQAKAANAjgbD8BEACgADQM4DBIAA==',
    },
  },
  {
    key: '[Runewords]/Weapon/Bows/Ice(HB)',
    value: {
      base64:
        'EAiABAQAdX9BNEusT9QOqYICQBEePFgy+h9BmrRLcqQxi4XMMXQH8rtsKZSnFP8BEACgADQA4Hw+ARAAoAA0BOB8tgEQAKAANAjgbD8BEACgADQM4DBIAA==',
    },
  },
  {
    key: '[Runewords]/Weapon/Bows/Wrath(GMB)',
    value: {
      base64:
        'EAiABAQA9FkRB+ECq7VDgqEAUIQHD5aMeAEA6L+MFB4aVXjyANVjMlNjihQFY8EVnv8QAKAANADgMJ8AEACgADQE4Hx8ABAAoAA0COBsvwMQAKAANAzgMNsA',
    },
  },
  {
    key: '[Runewords]/Weapon/Bows/Wrath(HB)',
    value: {
      base64:
        'EAiABAQQdH9BvO5p0NEOCYYCQBEePFgy+i8jhYdGFZ48QPW0zNSYIkXBWHCF5z8QAKAANADgMJ8AEACgADQE4Hx8ABAAoAA0COBsvwMQAKAANAzgMNsA',
    },
  },
  {
    key: '[Runewords]/Weapon/Flail/Call to Arms(CTA)(Flail)',
    value: {
      base64:
        'EAiABMwuQL6vphe/tmqHnEDx8FARAgQIU4kIs2n4H+HdOyVqF14YSUSYSkKYTcOf/AcQAKAANADgfD4BEACgADQE4HwjARAAoAA0COAw2wAQAKAANAzgMF8BEACgADQQ4DA+',
    },
  },
  {
    key: '[Runewords]/Weapon/Flail/Heart of the Oak(HOTO)(Flail)',
    value: {
      base64:
        'EAiABARAVb4v6kA27GuHNEHx8ED/T8BLAW8FvBbwlMhNsjS8P2PmdMPDw4wQJyPjPxAAoAA0AOB8kAAQAKAANATgMPsAEACgADQI4DCfABAAoAA0DOB8vgM=',
    },
  },
  {
    key: '[Runewords]/Weapon/Swords/Death(PB)',
    value: {
      base64:
        'EAiABAQIxItTkbEjErVDXKAAVIQHD5aM/kcIHBiRDNNh0g2ZYmwNZGZWFQ8P+oj/EACgADQA4HzQAhAAoAA0BOB8fwIQAKAANAjgMPsAEACgADQM4Hy7ABAAoAA0EOAwaAE=',
    },
  },
  {
    key: '[Runewords]/Weapon/Swords/Destruction(PB)',
    value: {
      base64:
        'EAiABAQQ1YtTwRbdBLRDZqAAVIQHD5aM/kfw6pUGGa06gWEWDI9iLQ5kY1c5BWMMPZf/EACgADQA4DD7ABAAoAA0BOAwSAAQAKAANAjgbL8DEACgADQM4Gw/ARAAoAA0EOB8kAA=',
    },
  },
  {
    key: '[Runewords]/Weapon/Swords/Fortitude(PB)',
    value: {
      base64:
        'EAiABAQAxIsTcYM2kLRDhqAAUIQHD5aM/kNAFoElyxPmUphbYa6FuTQtOUyyhwcKNuY/EACgADQA4Hx/AhAAoAA0BOB8mAAQAKAANAjgfL4CEACgADQM4DBIAA==',
    },
  },
  {
    key: '[Runewords]/Weapon/Swords/Grief(PB)',
    value: {
      base64:
        'EAiABAQAxItTZ0MUlbVDkqAAVIQHD5aM/lt5dOG9IT2nscei0bwHasZ/EACgADQA4HyjBRAAoAA0BOB8bwMQAKAANAjgMEgAEACgADQM4DDbABAAoAA0EOB8IwE=',
    },
  },
  {
    key: '[Runewords]/Weapon/Swords/Last Wish(PB)',
    value: {
      base64:
        'EAiABAQQ1IuTW+69vrVDvqAAWIQHD5aM/ke4exeR7JKYOIwygWJMkkKRbFnIAI/4DxAAoAA0AOBsPwEQAKAANATgMNsAEACgADQI4Gw/ARAAoAA0DOAwLhAAoAA0EOBsPwEQAKAANBTgbL8D',
    },
  },
  {
    key: '[Runewords]/Weapon/Swords/Lawbringer(PB)',
    value: {
      base64:
        'EAiABAQAxIvTSpKxG7VDwqAATIQHD5aM/oPQB8NSmg1BWrRs0pFduiONPVdQ/gMQAKAANADgfD4BEACgADQE4DDfARAAoAA0COB8kAA=',
    },
  },
  {
    key: '[Runewords]/Weapon/Swords/Oath(PB)',
    value: {
      base64:
        'EAiABAQQxIsTl0M5B7RD6KAAUIQHD5aM/kegSrWLbNIDU2NUFx5mkRYODswgdigo/gMQAKAANADgfLYBEACgADQE4DCfABAAoAA0COAw2wAQAKAANAzgfHwA',
    },
  },
  {
    key: '[Runewords]/Weapon/Swords/Phoenix(PB)',
    value: {
      base64:
        'EAiABAQQxIsTPWgdDrRDAKEAUIQHD5aM/keADBkE5EeVS3yaMSsc1DHUBXJTjv8QAKAANADgMPsAEACgADQE4DD7ABAAoAA0COAwSAAQAKAANAzgbD8B',
    },
  },
  {
    key: '[Runewords]/Weapon/Swords/Spirit(PB)',
    value: {
      base64:
        'EAiABARI1YsT5bI/0LVDNqEAUIQHD5aM/g+wJYAEoW/MMs3tjyYh/gMQAKAANADgfPsAEACgADQE4Hy+AxAAoAA0COB8uwAQAKAANAzgfD4B',
    },
  },
  {
    key: '[Runewords]/Weapon/Swords/Voice of Reason(PB)',
    value: {
      base64:
        'EAiABAQQxIsTra0+1rRD+KAAUIQHD5aM/tsg47abR66eepkao1qQGGuAeDzF+A8QAKAANADgMN8BEACgADQE4HyQABAAoAA0COB8fwIQAKAANAzgfDMB',
    },
  },
  {
    key: '[Runewords]/Weapon/Class-Items/Obsession(Fire)',
    value: {
      base64:
        'EAiABA0RYA8oAwAAAGiFOygaGmzNi63BsTU99n+DxAmCKQiuINiCIBNtDDRN9Q+TKUhg/gMQAKAANADgbLcBEACgADQE4DBfARAAoAA0COAw3wEQAKAANAzgfHwAEACgADQQ4Hz2ARAAoAA0FOB8fwU=',
    },
  },
  {
    key: '[Runewords]/Weapon/Crescent Moon(CS)',
    value: {
      base64:
        'EAiABAUgVBxqAAAAAClhBQoFhfkfgRu3OSctjDUqHIxFNSiYSeN4eDgd+Q8QAKAANADgfLYBEACgADQE4DBMABAAoAA0COB8bwM=',
    },
  },
  {
    key: "[Sets]/Aldur's Watchtower/Armor",
    value: {
      base64:
        'EAiAAAUABMIb5G1RsMbFELiRkZE4AGgEvD7YJIW+LTK8UgDCSwUg/we8/g94/R/w+g8=',
    },
  },
  {
    key: "[Sets]/Aldur's Watchtower/Boots",
    value: {
      base64: 'EACAAAUIhBsNyXemd+OiCORAQsI5IGUBNQeQE/rA8OQomP4X8Pov4PVfwOs/',
    },
  },
  {
    key: "[Sets]/Aldur's Watchtower/Helmet",
    value: {
      base64: 'EAiAAAWIZDxIGMmhzx0XQmALFBTkbIj4QIYV+rLkmNb/AK//AV7/A7z+Aw==',
    },
  },
  {
    key: "[Sets]/Aldur's Watchtower/Weapon",
    value: {
      base64:
        'EAiAAAUQxFkTbueBvMYFEUBCMqcCasEnQ16Ch8JHoYssD7f/AF7+A3j5D+DlPw==',
    },
  },
  {
    key: '[Sets]/Angelic Raiment/Amulet',
    value: {
      base64: 'EACAAAQM5FkYjkwt57oVasDIcnKo/wfW/P+T/w==',
    },
  },
  {
    key: '[Sets]/Angelic Raiment/Armor',
    value: {
      base64: 'EAiAAARA5LArWMhpRS+KGbADDQ0xIKAQMfz/AIr/J/T9Bw==',
    },
  },
  {
    key: '[Sets]/Angelic Raiment/Ring',
    value: {
      base64: 'EACAAAUA5PzY0KAQAHqtQQPGARpKyP/gsP9QLP8D',
    },
  },
  {
    key: '[Sets]/Angelic Raiment/Weapon',
    value: {
      base64: 'EAiAAAUIhPQE32K1GFQhA0BAxJiwhB6H/yMsWfK/i+w/',
    },
  },
  {
    key: "[Sets]/Arcanna's Tricks/Amulet",
    value: {
      base64: 'ECCAAATI5FkY6uIBn7UVdMBI8LKB4j8Uy/8nuP0H',
    },
  },
  {
    key: "[Sets]/Arcanna's Tricks/Armor",
    value: {
      base64: 'EAiAAAQI5JoZxhQuNrpFD6gDD48YIoYs9v+DG/4HUP0H',
    },
  },
  {
    key: "[Sets]/Arcanna's Tricks/Helmet",
    value: {
      base64: 'ECiAAAQQhKQZ6GVnbLQFD6iAhIQYSkQngv/WsP8prv0H',
    },
  },
  {
    key: "[Sets]/Arcanna's Tricks/Weapon",
    value: {
      base64: 'EAiAAAQABJAJOkXuNdpiB8jIiDElaZT5n0Dq/4aC/w==',
    },
  },
  {
    key: '[Sets]/Artic Gear/Armor',
    value: {
      base64: 'EAiAAARAZBP+wt5MUEShuAEWoKAQA0LRE9JSSFshrYW0/9aw/yuu/Qc=',
    },
  },
  {
    key: '[Sets]/Artic Gear/Belt',
    value: {
      base64: 'EACAAAQAZKc35APGgmkLHNAABwfjAwpWwPsPhfH/Cmn/AQ==',
    },
  },
  {
    key: '[Sets]/Artic Gear/Gloves',
    value: {
      base64: 'EACAAAQQxKwbJMiJhbVFDqiAhIRxgEYXz/8JMvwXoPoP',
    },
  },
  {
    key: '[Sets]/Artic Gear/Weapon',
    value: {
      base64: 'EAiAAAQIhIAGKM5Cam1hA2BgxIggQ8YdFP/BQf9tUHhY+g8=',
    },
  },
  {
    key: "[Sets]/Beserker's Arsenal/Armor",
    value: {
      base64: 'EAiAAAQIhOYNkw+wKNqiBaTBw0OEEcIU5r817D8=',
    },
  },
  {
    key: "[Sets]/Beserker's Arsenal/Helmet",
    value: {
      base64: 'EAiAAAQQBF8bXKWtFG0FC+AABoYIHzJwItx/cNB/',
    },
  },
  {
    key: "[Sets]/Beserker's Arsenal/Weapon",
    value: {
      base64: 'EAiAAAQAhHk8BEM+AHALF4CBIYKPwh0Z/yPIkPEf',
    },
  },
  {
    key: "[Sets]/Bul Kathos' Children/Colossus Blade",
    value: {
      base64: 'EAiAAAQAxK8xwCLvsWmLOSAjI0AEZMhOcEvBbQW3FtyiBLqgEI3+Aw==',
    },
  },
  {
    key: "[Sets]/Bul Kathos' Children/Mythical Sword",
    value: {
      base64:
        'EAiAAAQIxIOxiB+pjWgLOsDCIgAAmgjIkJ3Ql+Off2R0Qf0HEACgADAA4Gw/AQ==',
    },
  },
  {
    key: "[Sets]/Cathan's Traps/Amulet",
    value: {
      base64: 'EACAAATE5FkYJnmMTTMVOMAY4wFU/k+Q4T+Uvv8=',
    },
  },
  {
    key: "[Sets]/Cathan's Traps/Armor",
    value: {
      base64: 'EAiAAAUARGA2ZB8pGFcLDVCFlhYxPmRgi8x/J4X/J8z9Bw==',
    },
  },
  {
    key: "[Sets]/Cathan's Traps/Helmet",
    value: {
      base64: 'EAiAAAQIxJIUHGwNxFDFBigBBYUICWhWhPtvDfoP',
    },
  },
  {
    key: "[Sets]/Cathan's Traps/Ring",
    value: {
      base64: 'EACAAAXA5PzYYAzzZHut0gGCCIGH4T8Alf8=',
    },
  },
  {
    key: "[Sets]/Cathan's Traps/Weapon",
    value: {
      base64: 'ECiAAAQQRMmEo2LlJG2RAVBQxPCTxFDwP4HU/xPSUkhbIa2FtP8=',
    },
  },
  {
    key: "[Sets]/Civerb's Vestments/Amulet",
    value: {
      base64: 'EACAAAQE5FkY6oFwkrQVAsDYgKJE/L8i3P8PI/gP',
    },
  },
  {
    key: "[Sets]/Civerb's Vestments/Shield",
    value: {
      base64: 'EAiAAARE5J4VPmxtTrUFAMAABoYYFJ4PGfifwOZ/C3H/AQ==',
    },
  },
  {
    key: "[Sets]/Civerb's Vestments/Weapon",
    value: {
      base64: 'EAiAAAQAZJEI1bYn35ZCAPDwiDBhCQuX/9qQ/w==',
    },
  },
  {
    key: "[Sets]/Cleglaw's Brace/Gloves",
    value: {
      base64: 'EACAAAQAxK4bekGfEb8FApgABIQQJWAp8x8c9R8=',
    },
  },
  {
    key: "[Sets]/Cleglaw's Brace/Shield",
    value: {
      base64: 'ECiAAAQQhOwNHYrdN9riAFAAAkKEDxtw8/X/xLUU11Zca3HtPw==',
    },
  },
  {
    key: "[Sets]/Cleglaw's Brace/Weapon",
    value: {
      base64: 'EAiAAAUI5NIYxvVKSquFAWBhEeGOjEay/9qU/w==',
    },
  },
  {
    key: "[Sets]/Cow King's Leathers/Armor",
    value: {
      base64:
        'AAiAAAQAhAwMziE8f4HCDrQABEQMCDxOaEuhbYW2FtqMFTVI/h/w8T9ZIUHtPw==',
    },
  },
  {
    key: "[Sets]/Cow King's Leathers/Boots",
    value: {
      base64: 'AACAAAQIZKcmXHmb/WiLO/AABwdAAO1DC2BkjIDSB0b2Hw==',
    },
  },
  {
    key: "[Sets]/Cow King's Leathers/Helmet",
    value: {
      base64: 'AAiAAAQQhL8ZNljc/wJFHfgBA4MYH6pg5385438niv8=',
    },
  },
  {
    key: "[Sets]/Death's Disguise/Belt",
    value: {
      base64: 'ECCAAAQE5OoNvnnVO9oCBjCAgUH44IFM/5+4luLaimstrv0H',
    },
  },
  {
    key: "[Sets]/Death's Disguise/Gloves",
    value: {
      base64: 'ECCAAARE5K4b8mlMObTFC2gAA4PQQp+br/9dZP8B',
    },
  },
  {
    key: "[Sets]/Death's Disguise/Weapon",
    value: {
      base64: 'EAiAAAUABNAYhrXtnXxFDGBhESFChgw8CP9tZCxZ+g8=',
    },
  },
  {
    key: "[Sets]/Griswold's Legacy/Armor",
    value: {
      base64: 'EAiAAAUAhL8TXAssucaFFGAOD48BAGg++GcLDy8NAP0H',
    },
  },
  {
    key: "[Sets]/Griswold's Legacy/Helmet",
    value: {
      base64: 'EAiAAAUIBB42YDP8H4+LKAALGRkSICw50SxFsxXNWjSDIriFR53wn1cGgP4D',
    },
  },
  {
    key: "[Sets]/Griswold's Legacy/Shield",
    value: {
      base64: 'EAiAAAUQZD45vG6NEI0LKrAOLS0DKFAf7HCiXop6K+q1qGem+h8=',
    },
  },
  {
    key: "[Sets]/Griswold's Legacy/Weapon",
    value: {
      base64: 'EAiAAA0RwAMKyUwMFeNiChgZoRMBHrwtUF14erj954UBoP8VFAuU/xUUC5T/',
    },
  },
  {
    key: "[Sets]/Heaven's Brethren/Armor",
    value: {
      base64: 'EAiAAAUEhB8KxGH9z+PCDFBDRkaAA2s++AfEiBAoW6D+Aw==',
    },
  },
  {
    key: "[Sets]/Heaven's Brethren/Helmet",
    value: {
      base64: 'EAiAAAQUBGIbqFh83TzFGUgFCooAAFQEvD7wYAvPGJaxAQnFfw==',
    },
  },
  {
    key: "[Sets]/Heaven's Brethren/Shield",
    value: {
      base64: 'EAiAAAQMBBoKVzSrDpiiDNACIEACQgrZBx6kMOfEY0b2Hw==',
    },
  },
  {
    key: "[Sets]/Heaven's Brethren/Weapon",
    value: {
      base64: 'EAiAAAQAxNsXuusQdzAFGeDhEQAGhYcuPGMDCwptzH8=',
    },
  },
  {
    key: "[Sets]/Hsaru's Defence/Belt",
    value: {
      base64: 'EACAAAQQxOoNntSVqdqiADwAAkI4QGMFt//WqP8=',
    },
  },
  {
    key: "[Sets]/Hsaru's Defence/Boots",
    value: {
      base64: 'EACAAAQIxKoJp9Y83tpiAEwAAkI4EQ4M6j846j8=',
    },
  },
  {
    key: "[Sets]/Hsaru's Defence/Shield",
    value: {
      base64: 'EACAAAQARKEISmPOntqCAECAgUEAoCJC+G+N+g8=',
    },
  },
  {
    key: "[Sets]/Hwanin's Majesty/Armor",
    value: {
      base64: 'EAiAAAQIhIsb8C+elbRFG0AGCYkABwh9kEaLcckGFRT/AQ==',
    },
  },
  {
    key: "[Sets]/Hwanin's Majesty/Belt",
    value: {
      base64: 'EACAAARIxOoNkTYwQ9rCDTwAAgKQMYQgh6kTsMb8Bw==',
    },
  },
  {
    key: "[Sets]/Hwanin's Majesty/Helmet",
    value: {
      base64: 'EAiAAAQYhB82+KqnoWkLNsAHGRkBIJAZoaxop0T+Dw==',
    },
  },
  {
    key: "[Sets]/Hwanin's Majesty/Weapon",
    value: {
      base64: 'EAiAAAQAxO3+oa5J20FbvAGAABGQIZuglIwigy48Y0MLiv8=',
    },
  },
  {
    key: '[Sets]/Immortal King/Armor',
    value: {
      base64:
        'EAiAAAVQBL4TnAgbYIzFERATD4/4HzTTQh8vEAAlK2go/B/T+r8C3v8T8P6ngPcfgoz/',
    },
  },
  {
    key: '[Sets]/Immortal King/Belt',
    value: {
      base64:
        'EACAAAUIZANrkK2u0jYWSMAHGBg+gJwPLjhBLsW5/x/m8H9M6z8EMv9JcPvPKwRA/wE=',
    },
  },
  {
    key: '[Sets]/Immortal King/Boots',
    value: {
      base64: 'EACAAAVIhGMNykCjTsNCCfwAA8M7wGSCGx+qAIb3H0rff14gAPr/QRX/7fwP',
    },
  },
  {
    key: '[Sets]/Immortal King/Gloves',
    value: {
      base64:
        'EACAAAUQhOMVQmFG5odFEvgBBoYPgEYA7cMSkhEmMP53af3/IIj/PBT/fSj+GxL/AQ==',
    },
  },
  {
    key: '[Sets]/Immortal King/Helmet',
    value: {
      base64: 'EAiAAAWQRB9awDkcTTIWRoAHNzcEfDjEk0RQGLMgLxEA/Qc=',
    },
  },
  {
    key: '[Sets]/Immortal King/Weapon',
    value: {
      base64:
        'EAiAAAUYxFsfkiGy14fFEuDhIT8CMmRdeHm46eGGCIXpfxjTjf/LOLr7b+OPreX/HF11Zek/Df20/wE=',
    },
  },
  {
    key: '[Sets]/Infernal Tools/Belt',
    value: {
      base64: 'EACAAAQIxOgNUBWTz9piBUBAQsI4QOPDCP63CPffzv8=',
    },
  },
  {
    key: '[Sets]/Infernal Tools/Helmet',
    value: {
      base64: 'EAiAAAQARLwZ4LpY7ENFCngAA4MIJ6SlkLZCWgtpcqj/1qD/',
    },
  },
  {
    key: '[Sets]/Infernal Tools/Weapon',
    value: {
      base64: 'EAiAAAQQZAE2mGAMbp4KFfDwIEIFZIryHxz1Hw==',
    },
  },
  {
    key: "[Sets]/Iratha's Finery/Amulet",
    value: {
      base64: 'ECCAAARI5FkYtAJMUbUVEkBoYc7N1/8T11JcW3GtxbX/',
    },
  },
  {
    key: "[Sets]/Iratha's Finery/Belt",
    value: {
      base64: 'EACAAAQIxOgNxvhap9+CAUBAokGoUFwoPozgvwDVfw==',
    },
  },
  {
    key: "[Sets]/Iratha's Finery/Gloves",
    value: {
      base64: 'ECCAAAQQxKwbQKoF/LSFAqiAhISwwpyd/7ug/gM=',
    },
  },
  {
    key: "[Sets]/Iratha's Finery/Helmet",
    value: {
      base64: 'EAiAAAUARBw2gPrCR4+LBXADGRkRTphLYe6/Neg/',
    },
  },
  {
    key: "[Sets]/Isenhart's Armory/Armor",
    value: {
      base64: 'EAiAAAUARA8FZlvV1nHxAJwgIyPCBxmMEP5bg/4D',
    },
  },
  {
    key: "[Sets]/Isenhart's Armory/Helmet",
    value: {
      base64: 'ECiAAAQYRMY3uKUDpWoLCEACDw8RBJhECP9PQEsBbQW0FtD+Aw==',
    },
  },
  {
    key: "[Sets]/Isenhart's Armory/Shield",
    value: {
      base64: 'ECiAAAQQZBkK+xAkKNrCAbQABUWEDzIARP6fgJYC2gpoLaD9Bw==',
    },
  },
  {
    key: "[Sets]/Isenhart's Armory/Weapon",
    value: {
      base64: 'EAiAAAUIRGkM1FDSL9SiAYCAiFBB6YL6D075Dw==',
    },
  },
  {
    key: "[Sets]/Mavina's Battle Hymn/Armor",
    value: {
      base64: 'EAiAAAVYBN4xuG7Zc46LLVAhGBghPqBlBLPFiFcAgJINNyisgf/HyP4D',
    },
  },
  {
    key: "[Sets]/Mavina's Battle Hymn/Belt",
    value: {
      base64: 'EACAAAUIZGOnATvwC3NcdAEXODggH3jgo5AlwaD+nwiXItyKcC3C/Qc=',
    },
  },
  {
    key: "[Sets]/Mavina's Battle Hymn/Gloves",
    value: {
      base64: 'EACAAAVIhJsVMilmHMYFF8iBhAQGQEXA6wMPbBhIsHzCyc7/Ngb5kf1fauQ/',
    },
  },
  {
    key: "[Sets]/Mavina's Battle Hymn/Helmet",
    value: {
      base64:
        'EAiAAAUgRPy2IfpO83tcaAEjUFCIkyDnAyiUoF1k///k/x0j/0+ESxFuRbgW4f4D',
    },
  },
  {
    key: "[Sets]/Mavina's Battle Hymn/Weapon",
    value: {
      base64: 'EAiAAAUA9FkRHPBZ8caFF7i5EScCL14TZOjC6xT4T0Mu739jDwyK/7wAAPQf',
    },
  },
  {
    key: "[Sets]/Milabrega's Regalia/Armor",
    value: {
      base64: 'EAiAAAQQ5L0TqPUHF78FBpgHD48IIgQng/8QyPwH',
    },
  },
  {
    key: "[Sets]/Milabrega's Regalia/Helmet",
    value: {
      base64: 'EAiAAAUARBw2cJlM4B6LC3ADGRkRDrxI8PJ/Bbz/',
    },
  },
  {
    key: "[Sets]/Milabrega's Regalia/Shield",
    value: {
      base64: 'EAiAAAUIRPqZoKjVxb4pKgAHPDzE+DACKHj/D0j5D0HGfw==',
    },
  },
  {
    key: "[Sets]/Milabrega's Regalia/Weapon",
    value: {
      base64: 'EAiAAAUYBNAMyOJ7Z9fCAhgZCRBBhowpSxb7Dw==',
    },
  },
  {
    key: "[Sets]/Naj's Ancient Vestige/Armor",
    value: {
      base64: 'EAiAAAQIBF4T1CK4/7RFHuAQD48AB8J8sMmJcCnCrQjXItwWFDntn/wH',
    },
  },
  {
    key: "[Sets]/Naj's Ancient Vestige/Circlet",
    value: {
      base64: 'EAiAAAQARPy+w/gTVIG20AMoGBkRAMDLhyrAyBiRJZMVNTD+Aw==',
    },
  },
  {
    key: "[Sets]/Naj's Ancient Vestige/Staff",
    value: {
      base64: 'EAiAAAQQZC8osEeXkGkLPDAyIkCAYQKzCJYsyTBaSCP7E2aLDUVF/wE=',
    },
  },
  {
    key: "[Sets]/Natalya's Odium/Armor",
    value: {
      base64: 'EAiAAAUABIob4DgFzQIFENAPCYkBH9bRIpybL14xAMKG/Ac=',
    },
  },
  {
    key: "[Sets]/Natalya's Odium/Boots",
    value: {
      base64: 'EACAAAUIhFsN7Dp9moEiCNgAQgj4cIgU4VaESyIDhhdP+A8=',
    },
  },
  {
    key: "[Sets]/Natalya's Odium/Helmet",
    value: {
      base64: 'EAiAAAUIlGMXsPYpLwKFDzgECooAAGgE+D7cZMRwglsKbiu4teD2Hw==',
    },
  },
  {
    key: "[Sets]/Natalya's Odium/Weapon",
    value: {
      base64: 'EAiAAAUQ1G+eQI5M1hEofgARkQARkCGDwRDBhowMsi68OfNw08PtPw==',
    },
  },
  {
    key: "[Sets]/Orphan's Call/Wilhelm's Pride",
    value: {
      base64: 'EACAAAQYZMNoSM1np8IUaaAGEhIAhCUrpPEo+Cj8Bw==',
    },
  },
  {
    key: "[Sets]/Orphan's Call/Magnus' Skin",
    value: {
      base64: 'EACAAAQIhO9WiEgq8sAUakAGDg4ABBkTyDhxLct1Qf0H',
    },
  },
  {
    key: "[Sets]/Orphan's Call/Guillaume's Face",
    value: {
      base64: 'EAiAAAQAhGMb0uj5RzAFGmgDCooAAF4g4BkjQzRq9PgP',
    },
  },
  {
    key: "[Sets]/Orphan's Call/Whitstan's Guard",
    value: {
      base64: 'EAiAAAQQhNsbyubStjDFGhACEJAAEF5RuLOkGZ6d/wE=',
    },
  },
  {
    key: "[Sets]/Sander's Folly/Boots",
    value: {
      base64: 'EACAAAQIZKcmJM751HALPgABBwcAQIkA1QQywPD+Aw==',
    },
  },
  {
    key: "[Sets]/Sander's Folly/Gloves",
    value: {
      base64: 'EACAAAQUZLduOHp+peAWfQACDg7AASQfRpDDAxKWdEH9Bw==',
    },
  },
  {
    key: "[Sets]/Sander's Folly/Helmet",
    value: {
      base64: 'EACAAASARLwZPvXONLjFHmgAwwLgBAHl0BryHw==',
    },
  },
  {
    key: "[Sets]/Sander's Folly/Weapon",
    value: {
      base64: 'EAiAAAQQRAEbYpANX7iFH3h4ECBBToQlS2xkLJHxgUiD+g8=',
    },
  },
  {
    key: "[Sets]/Sazabi's Grand Tribute/Armor",
    value: {
      base64: 'EAiAAAQIBM4bDp/fOrRFHHiQh4cAAHIOrPmgmTGyPaz9Bw==',
    },
  },
  {
    key: "[Sets]/Sazabi's Grand Tribute/Helmet",
    value: {
      base64: 'EAiAAAQQhOMbiPq607SFHPCCh4cAH9xwglsKbn/yHw==',
    },
  },
  {
    key: "[Sets]/Sazabi's Grand Tribute/Weapon",
    value: {
      base64: 'EAiAAAQAxF8KnCiVb9oCDgAEAFAi4BXBkiUbGSNkuvDySP0P',
    },
  },
  {
    key: "[Sets]/Sigon's Complete Steel/Armor",
    value: {
      base64: 'EAiAAAQYZBkcrh+zXWBFCYjEzY0IEDKkMPffCeU/',
    },
  },
  {
    key: "[Sets]/Sigon's Complete Steel/Belt",
    value: {
      base64: 'EACAAAWgBOsN0K8ypcviBFQAA0M4QOMEt//WoP8=',
    },
  },
  {
    key: "[Sets]/Sigon's Complete Steel/Boots",
    value: {
      base64: 'EACAAAUQBKsJsBx4SrzCBGQAA8NYAQ8M6v8EGf5DsfwP',
    },
  },
  {
    key: "[Sets]/Sigon's Complete Steel/Gloves",
    value: {
      base64: 'EACAAAUABK8bNN3Sta/FCMgABoYAQGUCBf+7yP4D',
    },
  },
  {
    key: "[Sets]/Sigon's Complete Steel/Helmet",
    value: {
      base64: 'EAiAAAQgZGEbItBWEDUFCWgBCooICXw+jOA/OOg/',
    },
  },
  {
    key: "[Sets]/Sigon's Complete Steel/Shield",
    value: {
      base64: 'EAiAAAQIxPxBKEvCD+8WKGAEPDwCUKD+5D8=',
    },
  },
  {
    key: "[Sets]/Tal Rasha's Wrappings/Amulet",
    value: {
      base64: 'EACAAI0I4FkYDg5FSsZVmgA5ICWBUop0MgYQpkT/03j+Aw==',
    },
  },
  {
    key: "[Sets]/Tal Rasha's Wrappings/Armor",
    value: {
      base64: 'EAiAAAVABBocJAM5c8fFEzjRzY0IHzQz4jkBLwW8FfCg8G5B+Z/G8x8=',
    },
  },
  {
    key: "[Sets]/Tal Rasha's Wrappings/Belt",
    value: {
      base64: 'EACAAAUAZMNqqBoZUBsXTEAGEBCGAFoCHyhzW6DklP8/GOF/Gs9/',
    },
  },
  {
    key: "[Sets]/Tal Rasha's Wrappings/Helmet",
    value: {
      base64: 'EAiAAAUAlZMU3DWhhMYFFAADBYUAB7gk8PlwgxPXUlxbca3FNR4KH4r/',
    },
  },
  {
    key: "[Sets]/Tal Rasha's Wrappings/Weapon",
    value: {
      base64:
        'EAiAAAWI9K8v8AHjuI8LJyAjI14A1YEsCdrSoNb00JofWhNE/6ck/5s+/Hf68H9pkP8=',
    },
  },
  {
    key: "[Sets]/Tancred's Battlegear/Amulet",
    value: {
      base64: 'EACAAAQY5FkYOKcRub8VQsAQIYwI/kOR/T+Bh/8=',
    },
  },
  {
    key: "[Sets]/Tancred's Battlegear/Armor",
    value: {
      base64: 'EAiAAAQQRIY3hEVyNWiLD7AKIyMRALwcQPLfGvQf',
    },
  },
  {
    key: "[Sets]/Tancred's Battlegear/Boots",
    value: {
      base64: 'EACAAAQI5KoJ9zPAcp8CBDSAgcEQoOKQ8R+M7D8Alf8=',
    },
  },
  {
    key: "[Sets]/Tancred's Battlegear/Helmet",
    value: {
      base64: 'ECiAAAQcRLENNBWpldpCBLgABUWECAoUTEDh/wlpKaStkNZC2n8=',
    },
  },
  {
    key: "[Sets]/Tancred's Battlegear/Weapon",
    value: {
      base64: 'EAiAAAQAxM5f0HIqdJ8VHkBDQ4wIUKBMWOJ/Apr/XVD/AQ==',
    },
  },
  {
    key: '[Sets]/The Disciple/Amulet',
    value: {
      base64: 'EACAAAQY5FkYBpfVrLRVvgBYoa2FPieKP/kP',
    },
  },
  {
    key: '[Sets]/The Disciple/Armor',
    value: {
      base64: 'EAiAAAQQBMJfEGxhjdMWYqA7FBQCfEjNCXA5+nhFRrIBhsx/',
    },
  },
  {
    key: '[Sets]/The Disciple/Belt',
    value: {
      base64: 'EACAAAQABFoRrK+gXbTFGFgCBAQAQEWA6gMPTlxLcW3FtRbX/gM=',
    },
  },
  {
    key: '[Sets]/The Disciple/Boots',
    value: {
      base64: 'EACAAAUIhF8Nnl1YlroiDLSAgQFYkPNhBGBkdv4H',
    },
  },
  {
    key: '[Sets]/The Disciple/Laying of Hands',
    value: {
      base64: 'EACAAARABN4VnjngDLoFGEACAwPwYQQn9HVB5ZFrbChD8R8=',
    },
  },
  {
    key: "[Sets]/Trang-Oul's Avatar/Armor",
    value: {
      base64: 'EAiAAAXMlMMblsJ49saFFQiLkZFQECyBINMC3hYeMDxeEgD6n0LffxLh/gM=',
    },
  },
  {
    key: "[Sets]/Trang-Oul's Avatar/Belt",
    value: {
      base64: 'EACAAAUAFBoRsJH/lsdFFmCChARxQEwCqQU+H9ygZNzCk+n/FfD+Aw==',
    },
  },
  {
    key: "[Sets]/Trang-Oul's Avatar/Gloves",
    value: {
      base64: 'EACAAAVAlNsVWhrBXsYFFrABBATwAQUrzKVB8YIAENMl/wE=',
    },
  },
  {
    key: "[Sets]/Trang-Oul's Avatar/Helmet",
    value: {
      base64: 'EAiAAAWAFWIX9F7sQsZFFTgFCooACWw/uEHJ6IQypvUf',
    },
  },
  {
    key: "[Sets]/Trang-Oul's Avatar/Shield",
    value: {
      base64:
        'EAiAAAWIlR1cUEZhqRgXV0AJFBTCAMgR8KLgfTjEiXot4PGKANB/qBn/lbT/AQ==',
    },
  },
  {
    key: "[Sets]/Vidala's Rig/Amulet",
    value: {
      base64: 'EACAAAQQ5FkYvoGzq7tVKEA48GIFt/9QLP8D',
    },
  },
  {
    key: "[Sets]/Vidala's Rig/Armor",
    value: {
      base64: 'EAiAAAQA5A4vjPCBD3yKCbABDAwxBKw+8OD/CXD/rVH/AQ==',
    },
  },
  {
    key: "[Sets]/Vidala's Rig/Boots",
    value: {
      base64: 'ECCAAAQUxKgJy9zu5dpCAlRAQkJYYAtG9v8EtBTQVkBrAe0/',
    },
  },
  {
    key: "[Sets]/Vidala's Rig/Weapon",
    value: {
      base64: 'EAiAAAQI5KoGnbo6Sm4RAVhYRJARUPAfHPQf',
    },
  },
  {
    key: "[Uniques]/Amulets/Atma's Scarab",
    value: {
      base64: 'EACAAAVg5FkYOPc/zsQXIkKLiTnMMIOMk0KWu4PCmCBE4T8=',
    },
  },
  {
    key: '[Uniques]/Amulets/Crescent Moon',
    value: {
      base64: 'EACAAAUg5FkY5ojzOb83HkKCphEKD4OPRxaRo/wH',
    },
  },
  {
    key: "[Uniques]/Amulets/Highlord's Wrath",
    value: {
      base64: 'EACAAAVM9FkYnoJo0ccXKEKKdTICD7qg/gTQ0zf8Bw==',
    },
  },
  {
    key: "[Uniques]/Amulets/Mara's Kaleidoscope",
    value: {
      base64: 'EACAAI0I4FkYIsDhvccXIAKAkgAlAaUBpRPmUphbYa6FuT/6Dw==',
    },
  },
  {
    key: '[Uniques]/Amulets/Metalgrid',
    value: {
      base64: 'EACAAAUM9FkYfodq0Mc37sIE4T6g5cS6FOtWrGuxjhnDBAUFM0uLhYX/',
    },
  },
  {
    key: '[Uniques]/Amulets/Nokozan Relic',
    value: {
      base64: 'EACAAAUk5FkYLlfAx8NX6sAJfSgUjAEDWW4M6j8=',
    },
  },
  {
    key: "[Uniques]/Amulets/Saracen's Chance",
    value: {
      base64: 'EACAAAWA5FkYHMld/8RXKgIAlgAsAawBrBPhUoRbEa5FuGQCE4r/',
    },
  },
  {
    key: "[Uniques]/Amulets/Seraph's Hymn",
    value: {
      base64: 'EACAAAXM9FkYZNMQJMcXXEIWy2NEj5E9evHR6494aQDoPw==',
    },
  },
  {
    key: "[Uniques]/Amulets/The Cat's Eye",
    value: {
      base64: 'EACAAAWk5FkYrvmwRcJXGoKA3Ac3gCDTBQVG9h8=',
    },
  },
  {
    key: '[Uniques]/Amulets/The Eye of Etlich',
    value: {
      base64: 'EACAAAVk5FkYdk71H8M37AAIFDYECkDxOGTJPzGk/gM=',
    },
  },
  {
    key: '[Uniques]/Amulets/The Mahim-Oak Curio',
    value: {
      base64: 'EACAAAWM9FkYTsH/4MAX7gAAlQAqAaoBKggKPlDghLQU0lZIayHtjof/',
    },
  },
  {
    key: '[Uniques]/Amulets/The Rising Sun',
    value: {
      base64: 'EACAAAXk5FkY8gjNDb1XHAIMDBhK0CzoJ0pG4SBYZ/wH',
    },
  },
  {
    key: "[Uniques]/Armors/Arkain's Valor",
    value: {
      base64: 'EAiAAAUAFM4b/G2DsMbHPoCQh4eAQEvEM0b2R9+I/w==',
    },
  },
  {
    key: "[Uniques]/Armors/Atma's Wail",
    value: {
      base64: 'EAiAAAVIhBsc7DbCIMQHN9DJzY0Q8IIAKomMErRJBgVvjMwa9B8=',
    },
  },
  {
    key: '[Uniques]/Armors/Black Hades',
    value: {
      base64: 'EAiAAAUQhMMbApX1Z8ZHNwiLkZGBgCyL2JkHyh69/gM=',
    },
  },
  {
    key: "[Uniques]/Armors/Blinkbat's Form",
    value: {
      base64: 'EAiAAAUA9A4vLD5qRHkPKIABDAzxYQQgZMAYMADGM4b3Hw==',
    },
  },
  {
    key: '[Uniques]/Armors/Boneflesh',
    value: {
      base64: 'EAiAAAUAZF4T9EwvrcYHFvgDD4+AgGfCCDwKhzL/AQ==',
    },
  },
  {
    key: '[Uniques]/Armors/Corpsemourn',
    value: {
      base64: 'EAiAAAUYhL8TdDAZXMGHN2gOD48AgDJABYHWinUwGEgkE5gwMCuUQEH5Dw==',
    },
  },
  {
    key: '[Uniques]/Armors/Crow Caw',
    value: {
      base64: 'EAiAAAUghIsb9GGECMSHNUgGCYkQ8IJAq8tozOjQ6D8=',
    },
  },
  {
    key: '[Uniques]/Armors/Darkglow',
    value: {
      base64:
        'EAiAAAUQ9LArpCJUnY2PKbADDQkBgcwECkLInJCGoqSQpqKskMaitJDmomS5/w==',
    },
  },
  {
    key: "[Uniques]/Armors/Duriel's Shell",
    value: {
      base64: 'EAiAAAUAlB8KCgr8ZeMDG1RDRkYAeIGA7AS3FNxWcGvBLQlZptYUbMgKff8B',
    },
  },
  {
    key: '[Uniques]/Armors/Goldskin',
    value: {
      base64: 'EAiAAAUIRIY38CzaqoqPLcAKIyMBwdKJdSnWrVjXYp0TxRNkWew/',
    },
  },
  {
    key: '[Uniques]/Armors/Greyform',
    value: {
      base64: 'EAiAAAUQZBP+QsASrOb4eAIVoJgQAlQfPDBiOMFtBTcehf8=',
    },
  },
  {
    key: '[Uniques]/Armors/Guardian Angel',
    value: {
      base64: 'EAiAAAUIlF8TJKnTvsOHNugID4+AgIwCheKpeCyeizdlyYJmZPWK/w==',
    },
  },
  {
    key: '[Uniques]/Armors/Hawkmail',
    value: {
      base64: 'EAiAAAUYhMQN1WVhIuODChyBhERAILPiGosHxpPpfw==',
    },
  },
  {
    key: '[Uniques]/Armors/Heavenly',
    value: {
      base64: 'EAiAAAUg5JoZ2qT0McZHF7ADD48I8IJAZkPGCWkppK2Q1kKaHiN8yPkP',
    },
  },
  {
    key: '[Uniques]/Armors/Iceblink',
    value: {
      base64: 'EAiAAAUAlOYNV1CQrePjCqjBw0NAgDIiWGEuCxoK/wE=',
    },
  },
  {
    key: '[Uniques]/Armors/Ironpelt',
    value: {
      base64: 'EAiAAAUQlBsYHrSmOLwHNSAFCIg4kAMCGRHUCChJnzXsPw==',
    },
  },
  {
    key: '[Uniques]/Armors/Leviathan',
    value: {
      base64: 'EAiAAAUIFN4x3OfRlI+PnmAhmBYBQAoCsg+gIBEO0/8=',
    },
  },
  {
    key: "[Uniques]/Armors/Que-Hegan's Wisdon",
    value: {
      base64: 'EAiAAAXAlJsZmvBT5MbHN4AID48I8IIAaoQyBpUG9SeKBv8B',
    },
  },
  {
    key: '[Uniques]/Armors/Rattlecage',
    value: {
      base64: 'EAiAAAUIdBkcitgp6r6HFojEzY2Y0MIHacCZIcr8Bw==',
    },
  },
  {
    key: '[Uniques]/Armors/Rockfleece',
    value: {
      base64: 'EAiAAAUIVL5jmExpPR8fWYAOMDACQAkEQSIKEtK2aP0H',
    },
  },
  {
    key: '[Uniques]/Armors/Shaftstop',
    value: {
      base64: 'EAiAAAXIlGM2rI04l4yPawCOlhZxgAsEbiD0kTD3Hw==',
    },
  },
  {
    key: '[Uniques]/Armors/Skin of the Flayerd One',
    value: {
      base64: 'EAiAAAXQlN8XcA8167/HNJgEB4eA4IvHIYmHktvJg5/yHw==',
    },
  },
  {
    key: '[Uniques]/Armors/Skin of the Vipermagi',
    value: {
      base64: 'EAiAAAUAhA8vHK4PF3kPaZAIDAwBAc+I5sS6FOtWrGuxLo3sT/4D',
    },
  },
  {
    key: "[Uniques]/Armors/Skullder's Ire",
    value: {
      base64: 'EAiAAAUAlM8b/Ki7fsBHNvCHh4eAgGyEkoTnT+Ap/Kj/',
    },
  },
  {
    key: '[Uniques]/Armors/Sparking Mail',
    value: {
      base64: 'EAiAAAUQRGA27MrXN46PKmCFlhYBoUoKczICCgCt/w==',
    },
  },
  {
    key: '[Uniques]/Armors/Spiritforge',
    value: {
      base64: 'EAiAAAUQlLMrkBCNvImPanALDQ0D4AUCqBPNYFAEyYLYlP8=',
    },
  },
  {
    key: '[Uniques]/Armors/Steel Carapice',
    value: {
      base64: 'EAiAAAUABMIbzNuW5ccHV8CRkZGAwG3DgwhnBcExqGQGEwh+xX8=',
    },
  },
  {
    key: "[Uniques]/Armors/Templar's Might",
    value: {
      base64: 'EAiAAAUEFL4TzpfXNcCHWxgTz4kA8DLgtUAKAjcQLMegeGUA6D8=',
    },
  },
  {
    key: '[Uniques]/Armors/The Centurion',
    value: {
      base64: 'EAiAAAUQFN8Xfu/7ksZHFBABB4c48CLBy4KXCTJ8QIEIQcmoqfUf',
    },
  },
  {
    key: "[Uniques]/Armors/The Gladiator's Bane",
    value: {
      base64: 'EAiAAAUMFBoYSMf3oceHPmAPCIiAgOwDD0RQI6gkZ04oY2RujDL9Dw==',
    },
  },
  {
    key: '[Uniques]/Armors/The Spirit Shroud',
    value: {
      base64: 'EAiAAAXIlMNfwItEmgsf0QAQFBQCgqURixL0TzL9Dw==',
    },
  },
  {
    key: '[Uniques]/Armors/Toothrow',
    value: {
      base64: 'EAiAAAXQlN8xrOFSjYOPbdAQGBgBQAUCtw9GOHEtyYMT1CHUfw==',
    },
  },
  {
    key: '[Uniques]/Armors/Twitchthroe',
    value: {
      base64: 'EAiAAAUQlAwM95L0YONDCrQABEQAUBGgopB9GEEX1BjUfw==',
    },
  },
  {
    key: "[Uniques]/Armors/Tyrael's Might",
    value: {
      base64: 'EAiAAATIFL4Tooek1LTHTRgTQADwgWDphLkU5laYa2FuCzIYFJt58GCa6X8=',
    },
  },
  {
    key: '[Uniques]/Armors/Venom Ward',
    value: {
      base64: 'EAiAAAXAVA8FmYU4zu9hBZ4gIyMgkGkh0sXLYm6M/gM=',
    },
  },
  {
    key: '[Uniques]/Armors/Victors Silk',
    value: {
      base64: 'EAiAAAUU5L0T2FhtPcYHF6AHD4+AgMdHIYv9yX8=',
    },
  },
  {
    key: '[Uniques]/Belts/Arachnid Mesh',
    value: {
      base64: 'EACAAA0iAF4RVOjtYcNHXUgCwwIIeJo8aVB/YknBbLBoYeE/',
    },
  },
  {
    key: '[Uniques]/Belts/Bladebuckle',
    value: {
      base64: 'EACAAAWMBOsNve0+Kt+DDlgAYwKAEgEqCGQ+oEDE4AQxRvYf',
    },
  },
  {
    key: '[Uniques]/Belts/Gloomstrap',
    value: {
      base64: 'EACAAAXgZMNqMGhTlAYf9GAGEA8GvCBY2vDgo9AkyxL/AQ==',
    },
  },
  {
    key: '[Uniques]/Belts/Goldwrap',
    value: {
      base64: 'EACAAAVMxOgNzcwspOFjDkRAogEEHh9G8IQWFMEs1sXzHw==',
    },
  },
  {
    key: '[Uniques]/Belts/Lenyms',
    value: {
      base64: 'EACAAAXA5OoNgfH4SeMDDjCAIUGClw0eJ5qlaLaiWYtmWeo/',
    },
  },
  {
    key: '[Uniques]/Belts/Nightsmoke',
    value: {
      base64: 'EACAAAUMxOoNFl+ms+NDDkAAAkECGggyPmRAhHBCWgppK6S1kCZH/g8=',
    },
  },
  {
    key: "[Uniques]/Belts/Nosferatu's Coil",
    value: {
      base64: 'EACAAAVAFe5E+N7tLvgedqEIDgcAvPA4ZIkuHkUCS4r/',
    },
  },
  {
    key: '[Uniques]/Belts/Razortail',
    value: {
      base64: 'EACAAAXYZGOngT/y/2B8zIMXODgQ8IJgyYICg+JDBjiFQCncof8=',
    },
  },
  {
    key: '[Uniques]/Belts/Snakecord',
    value: {
      base64: 'EACAAAXIZKc3aDjxh4CPOOAAhwMQPHygQItwOVBAYYmS0Y3Rfw==',
    },
  },
  {
    key: '[Uniques]/Belts/Snowclash',
    value: {
      base64: 'EACAAAXQZMNo2OXnsBkf9aAGEhIgqGLxbDRUWFpzY2t2aA0PVXoko3Yo/Ac=',
    },
  },
  {
    key: '[Uniques]/Belts/String of Ears',
    value: {
      base64: 'EACAAAXAZONqECD2Lh0f8qAFDAwg0PqQgREPiWs8EEkU/gM=',
    },
  },
  {
    key: "[Uniques]/Belts/Thundergod's Vigor",
    value: {
      base64: 'EACAAAUIZANrKJ+FEQYf9uAHGBgA0AygQUCmQskIZFgjYmtGLBIl2ZFH4T8=',
    },
  },
  {
    key: "[Uniques]/Belts/Verdungo's Hearty Cord",
    value: {
      base64: 'EACAAAWAFVoRwGe4N8YHXmAChIIByAWYEBiRuKZkHeP5Dw==',
    },
  },
  {
    key: '[Uniques]/Boots/Goblin Toe',
    value: {
      base64: 'EACAAAXA1KgJcUO18+PDDVhAggEEHh8yICIYEWQZRJn/',
    },
  },
  {
    key: '[Uniques]/Boots/Gorefoot',
    value: {
      base64: 'EACAAAXIdKcmgBusQ4UPNhABBwQQPHywgA+BkwMY1BpCYkT4Dw==',
    },
  },
  {
    key: '[Uniques]/Boots/Gorerider',
    value: {
      base64: 'EACAAAUAhGMNIOgXWuMjHgABA8MCGgjIkihsWQIjO6RA9Gj0+A8=',
    },
  },
  {
    key: '[Uniques]/Boots/Hotspur',
    value: {
      base64: 'EACAAAXQ9KoJQDRTAt9jDTiAwcCBFxAofIDAiXooHowBA/8B',
    },
  },
  {
    key: '[Uniques]/Boots/Infernostride',
    value: {
      base64: 'EACAAAWAhF8NnbPA8uOjHbiAgQEESx8ycMIcCgWDIcQTVVkMDCoZ4kLhPw==',
    },
  },
  {
    key: '[Uniques]/Boots/Marrowwalk',
    value: {
      base64:
        'EACAAAVQFVoNTZZh2uNDLjgBAgIAGgExCMg2KHBQAINaU0R2MmOkUFBgFmLR0PAf',
    },
  },
  {
    key: '[Uniques]/Boots/Sandstorm Trek',
    value: {
      base64: 'EACAAAUIBO40AAAAAIyPuLAEBwcAXga8IKhq4RAMagxKk1Eewq/4Dw==',
    },
  },
  {
    key: '[Uniques]/Boots/Shadowdancer',
    value: {
      base64: 'EACAAE0mAGINP/d2kuOjJkgBA4OAHAQyW6DAyMbIeMUA6D8=',
    },
  },
  {
    key: '[Uniques]/Boots/Silkweave',
    value: {
      base64: 'EACAAAUIhFsNWV3yBd/jHdwAAgIEXyCQNaHAyBQV/gM=',
    },
  },
  {
    key: '[Uniques]/Boots/Tearhaunch',
    value: {
      base64: 'EACAAAVAFasJlLwp1t/jDWgAwwGAEgElCFA+tOCEtBTSVkhrIQ0Mas0c/Qc=',
    },
  },
  {
    key: '[Uniques]/Boots/Treads of Cthon',
    value: {
      base64: 'EACAAAVI1aoJ/ed7O9+jDVAAYsEBFRBQfLAACBlgZJqM/wE=',
    },
  },
  {
    key: '[Uniques]/Boots/Wartraveler',
    value: {
      base64:
        'EACAAAWIhBsNpizGb+IDHuhAQgIAlQEqCL4qPBYyFx4MmSQeThRQLMG0NPE+PaAy/wE=',
    },
  },
  {
    key: '[Uniques]/Boots/Waterwalk',
    value: {
      base64: 'EACAAAUQhO80+J0GFYsPdyADhwUCXgfCLECCII2DDAgyKAoY1H8=',
    },
  },
  {
    key: '[Uniques]/Charms/Annihilus',
    value: {
      base64: 'EACAAAVARNhPOFKS4Qzc6AsAaALQBNAG0E5wS8FtBbcW3Krw+JP/',
    },
  },
  {
    key: "[Uniques]/Charms/Gheed's Fortune",
    value: {
      base64: 'EACAAAUAVNhtsPfzHhTcOAtPCEJhvPL4Dw==',
    },
  },
  {
    key: '[Uniques]/Charms/Sunder/Bone Break',
    value: {
      base64: 'EACAAAUIRNhtmFzy/7heqQwkfAFj6T8=',
    },
  },
  {
    key: '[Uniques]/Charms/Sunder/Black Cleft',
    value: {
      base64: 'EACAAAXAVNht8JNXcrtesAwlNgVj6T8=',
    },
  },
  {
    key: '[Uniques]/Charms/Sunder/Crack of the Heavens',
    value: {
      base64: 'EACAAAWAVdht+BfgLr5emQwpBPli6T8=',
    },
  },
  {
    key: '[Uniques]/Charms/Sunder/Cold Rupture',
    value: {
      base64: 'EACAAAUEVNhtaJnZQLleiAwrBO1i6T8=',
    },
  },
  {
    key: '[Uniques]/Charms/Sunder/Flame Rift',
    value: {
      base64: 'EACAAAUMRNht2GQFj71ekQwnBPVi6T8=',
    },
  },
  {
    key: '[Uniques]/Charms/Sunder/Rotting Fissure',
    value: {
      base64: 'EACAAAXEVNhtWIZaQ7heoAwtBP1i6T8=',
    },
  },
  {
    key: '[Uniques]/Class-Items/Ama/Amazon Torch',
    value: {
      base64:
        'EACAAAQARFgmBAw+JHEvQAYANAFoAmgDaCe4peC2glsLblOwLGxMKSbDzPNBQeE/',
    },
  },
  {
    key: "[Uniques]/Class-Items/Ama/Bloodraven's Charge",
    value: {
      base64: 'EAiAAAUQ5FkNChoP2OGDKcDAiAjmzN0B6qnBCwCAzIovPDz+Aw==',
    },
  },
  {
    key: "[Uniques]/Class-Items/Ama/Lycander's Aim",
    value: {
      base64: 'EAiAAAUA5FkfAAAAAMaHRri5EQFoAmgQKERAhuxChkHmAzEF6oLiBQCg/w==',
    },
  },
  {
    key: "[Uniques]/Class-Items/Ama/Lycander's Flank",
    value: {
      base64: 'ECiAAAUA5FkXTh+M7GXHRshoEABoBtAgUIiADNmFDIOMR2IK1EXGSwBA/wE=',
    },
  },
  {
    key: '[Uniques]/Class-Items/Ama/Thunderstroke',
    value: {
      base64: 'EACAAAUE5Fk52FxqDYYPqWBgAEoEZMhkBP91Ga2hMF4CADTmxEBx+vAf',
    },
  },
  {
    key: "[Uniques]/Class-Items/Ama/Titan's Revenge",
    value: {
      base64:
        'EACAAAUE5NkXAAAAAMZHRjAwwAgAjQBaBGTIKmQWZDwSUyAwsk8ZKBkvAQD18/zx/Ac=',
    },
  },
  {
    key: '[Uniques]/Class-Items/Assa/Assassin Torch',
    value: {
      base64:
        'EACAAASIRFgmcPW8hXEvQAYANAFoAmgDaCe4peC2glsLblO8LGxMKSbDzPNBQeE/',
    },
  },
  {
    key: "[Uniques]/Class-Items/Assa/Bartuc's Cutthroat",
    value: {
      base64:
        'EAiAAAQIxBkQMLeRxbSHRygqEgBoBNAiIENWIbMg45GYYnE5jJHdQcFLBiD/AQ==',
    },
  },
  {
    key: '[Uniques]/Class-Items/Assa/Jadetalon',
    value: {
      base64: 'EACAAAUUxAMNdzHomeODJuCkiAAP3gl9KfSt0NdCn4/HGBmvGADxkgHQfw==',
    },
  },
  {
    key: "[Uniques]/Class-Items/Barb/Arreat's Face",
    value: {
      base64:
        'EAiAAAUARN8Lh4Sa7ODjIgzi5kYAoBFAg4DshLkU5laYa2GOh2EKNUZ2BwUvEAD9Bw==',
    },
  },
  {
    key: '[Uniques]/Class-Items/Barb/Barbarian Torch',
    value: {
      base64:
        'EACAAAQIVFgmrOwNuHAvQAYANAFoAmgDaCe4peC2glsLblO4LGxMKSbDzPNBQeE/',
    },
  },
  {
    key: "[Uniques]/Class-Items/Barb/Demonhorn's Edge",
    value: {
      base64: 'EAiAAAWURN8Ygrg/W8ZHUThFy4eAAIqHwUmzi4cXCMB4hQCMlwjA/gM=',
    },
  },
  {
    key: "[Uniques]/Class-Items/Barb/Halaberd's Reign",
    value: {
      base64: 'EAiAAAUIRN8QiEi9P8FHWlCFjIyAoEpJPYUag1pTSWs2iVcIQP4D',
    },
  },
  {
    key: '[Uniques]/Class-Items/Barb/Wolfhowl Fury',
    value: {
      base64:
        'EAiAAAUQRJ8IZN90EoJjLIRiZEQAeBHwGvCCYCnMNyMMOCMMOoOXCMCYPe1ISPwH',
    },
  },
  {
    key: "[Uniques]/Class-Items/Dru/Cerebus' Bite",
    value: {
      base64: 'EAiAAAWUZDwaDHatpbyHTeAEBYSAwIiHYg063WF0KMQrBYD/AQ==',
    },
  },
  {
    key: '[Uniques]/Class-Items/Dru/Druid Torch',
    value: {
      base64:
        'EACAAARkRFgmrOwNuHAvQAYANAFoAmgDaCe4peC2glsLblO6LGxMKSbDzPNBQeE/',
    },
  },
  {
    key: "[Uniques]/Class-Items/Dru/Jalal's Mane",
    value: {
      base64:
        'EAiAAAUMZDwvfK3EMnuPj8AGCgoBgCYADQKyE+ZSmFthroW5KRWXwxjZHRSKCrxSAPQf',
    },
  },
  {
    key: '[Uniques]/Class-Items/Dru/Ravenlore',
    value: {
      base64: 'EAiAAAWUZDxDON4ppAUfXsEUFA0igA+CpRPhUoRbEa5FuDXdzksFYE0p/gM=',
    },
  },
  {
    key: '[Uniques]/Class-Items/Dru/Spiritkeeper',
    value: {
      base64: 'EAiAAAWcZDxjcHpa9R8fR2EUFBACgq8T8FyoKdUYVCQHpcx/',
    },
  },
  {
    key: '[Uniques]/Class-Items/Necro/Arm of King Leoric',
    value: {
      base64:
        'EAiAAAWExCkIx7l/yOCjETw8iDSeNUW2xsjWNNEaKOIVASBeEgBKJmChSKZ0Ucim/Ac=',
    },
  },
  {
    key: '[Uniques]/Class-Items/Necro/Boneflame',
    value: {
      base64: 'EAiAAAWUhB2GcNGqdys4qkInKBoEBEsnzKUwt8JcC3NTNDCoZEMTj/8=',
    },
  },
  {
    key: '[Uniques]/Class-Items/Necro/Boneshade',
    value: {
      base64: 'EAiAAAWgxCsIfWR9j+DjK0QsiClSmtaaIV1DpGucbA2Vremi/w==',
    },
  },
  {
    key: '[Uniques]/Class-Items/Necro/Darkforge Spawn',
    value: {
      base64: 'EAiAAAWUhB3kQCPHVT0+lMInKBwEBFpNqDQyXhAA4xUBMF4SAPsP',
    },
  },
  {
    key: "[Uniques]/Class-Items/Necro/Deaths's Web",
    value: {
      base64: 'EAiAAAVkxC8QGIqOjMbHSpCAEFYYf6SIwSsCQFBl/gM=',
    },
  },
  {
    key: '[Uniques]/Class-Items/Necro/Homunculus',
    value: {
      base64:
        'EAiAAAWMhB1e+BIwMBccGAEKFBQiAA0CMgrohpAT8FLAWwGvBbwpEpeDGZmiAi8IAP0H',
    },
  },
  {
    key: '[Uniques]/Class-Items/Necro/Necromancer Torch',
    value: {
      base64:
        'EACAAAQQVFgmrOwNuHAvQAYANAFoAmgDaCe4peC2glsLblO0LGxMKSbDzPNBQeE/',
    },
  },
  {
    key: '[Uniques]/Class-Items/Pala/Alma Negra',
    value: {
      base64: 'EAiAAAUQdD4RzD8eFr5HUngFkZCAIC3CkiUUqBHJlMmM7M6X/w==',
    },
  },
  {
    key: "[Uniques]/Class-Items/Pala/Astreon's Ironward",
    value: {
      base64: 'EAiAAAUgxAMKeA57nuODLxixiAgiRYo4aEDB6+J5k+YON0QhSxleGAD8Dw==',
    },
  },
  {
    key: '[Uniques]/Class-Items/Pala/Dragonscale',
    value: {
      base64: 'EAiAAAUIdL4hZHK00I+PrcCMoCABIAcCMhQFxvTcMD4UR5SkQf4D',
    },
  },
  {
    key: '[Uniques]/Class-Items/Pala/Herald of Zakarum',
    value: {
      base64:
        'EAiAAAQQZD4XJt/KwLRHR5iFjIwAQDOABgEZBe+EvhT6VuhroW/KZEZ2BwUvDAD9Bw==',
    },
  },
  {
    key: '[Uniques]/Class-Items/Pala/Paladin Torch',
    value: {
      base64:
        'EACAAATAVFgmrOwNuHAvQAYANAFoAmgDaCe4peC2glsLblO2LGxMKSbDzPNBQeE/',
    },
  },
  {
    key: "[Uniques]/Class-Items/Sorc/Death's Fathom",
    value: {
      base64: 'EAiAAAUA5K9y0PEPXRgfYkFGRpyAlwLelCwNaimU/w==',
    },
  },
  {
    key: '[Uniques]/Class-Items/Sorc/Eschutas Temper',
    value: {
      base64: 'EAiAAAUA5K8i3FmiIoyPt+DBIQL4pmRpeEmNKDXyHw==',
    },
  },
  {
    key: "[Uniques]/Class-Items/Sorc/Ormus' Robes(Blizzard)",
    value: {
      base64: 'EAiAAAXAFMJf2OM7IQ0fZgE7FBRiw8MHD6RBrdmxpEGUBlka5D8=',
    },
  },
  {
    key: "[Uniques]/Class-Items/Sorc/Ormus' Robes(Chain Ligthing)",
    value: {
      base64: 'EAiAAAUAFMJf2OM7IQ0fZgE7FBRiw8MHD6RBramxpEGUBlka5D8=',
    },
  },
  {
    key: "[Uniques]/Class-Items/Sorc/Ormus' Robes(Fire Ball)",
    value: {
      base64: 'EAiAAAUIFMJf2OM7IQ0fZgE7FBRiw8MHD6RBrXmxpEGUBlka5D8=',
    },
  },
  {
    key: "[Uniques]/Class-Items/Sorc/Ormus' Robes(Fire Mastery)",
    value: {
      base64: 'EAiAAAUQFMJf2OM7IQ0fZgE7FBRiw8MHD6RBremxpEGUBlka5D8=',
    },
  },
  {
    key: "[Uniques]/Class-Items/Sorc/Ormus' Robes(Lightning)",
    value: {
      base64: 'EAiAAAUAFMJf2OM7IQ0fZgE7FBRiw8MHD6RBrYmxpEGUBlka5D8=',
    },
  },
  {
    key: "[Uniques]/Class-Items/Sorc/Ormus' Robes(Meteor)",
    value: {
      base64: 'EAiAAAXIFMJf2OM7IQ0fZgE7FBRiw8MHD6RBrcGxpEGUBlka5D8=',
    },
  },
  {
    key: "[Uniques]/Class-Items/Sorc/Ormus' Robes(Frozen Orb)",
    value: {
      base64: 'EAiAAAXQFMJf2OM7IQ0fZgE7FBRiw8MHD6RBrQGypEGUBlka5D8=',
    },
  },
  {
    key: '[Uniques]/Class-Items/Sorc/Sorceress Torch',
    value: {
      base64:
        'EACAAATEVFgmrOwNuHAvQAYANAFoAmgDaCe4peC2glsLblOyLGxMKSbDzPNBQeE/',
    },
  },
  {
    key: '[Uniques]/Class-Items/Sorc/The Oculus',
    value: {
      base64:
        'EAiAAAVk5K8vVP5tno4PjiCjIgLQBtAgUDjBLQW3FdxacINiOSVLI1NUSBbYkPkP',
    },
  },
  {
    key: '[Uniques]/Gloves/Bloodfist',
    value: {
      base64: 'EACAAAUAZLduAPTO6x8fZyACDg4OIIFAoUJxofhAgS6eMbJPxX8=',
    },
  },
  {
    key: '[Uniques]/Gloves/Chance Guards',
    value: {
      base64: 'EACAAAWAxK4bEgeGJbwHGqAABAQIHiZk8CEDT1hCYcxi/wE=',
    },
  },
  {
    key: "[Uniques]/Gloves/Dracul's Grasp",
    value: {
      base64: 'EACAAAVIFe5WcGMICxwfbIEJDg4AvEDAw0NhRXEoY0yRovAf',
    },
  },
  {
    key: '[Uniques]/Gloves/Frostburn',
    value: {
      base64: 'EACAAAUIBK8bOJ00wLyHGtAABgYIFCIUKPABBTYCDMg0kf8D',
    },
  },
  {
    key: '[Uniques]/Gloves/Ghoulhide',
    value: {
      base64: 'EACAAAUAhNsVRIvrh8eHOrgBBIQDNCD48lGgB9mD/gM=',
    },
  },
  {
    key: '[Uniques]/Gloves/Gravepalm',
    value: {
      base64: 'EACAAAUAhO9WGPbpVxMf6UAGDg4AqARQQaClhxsfpP4D',
    },
  },
  {
    key: '[Uniques]/Gloves/Hellmouth',
    value: {
      base64: 'EACAAAUIhOMVeOisbMcHOwACBgYIyGA8IEny8OhhjMBBYIwJh/Af',
    },
  },
  {
    key: '[Uniques]/Gloves/Lavagout',
    value: {
      base64: 'EACAAAWIhJsV7len38fHOtCBhAQIyE6Ag9HgIglFF5SdxhQaBP8B',
    },
  },
  {
    key: '[Uniques]/Gloves/Magefist',
    value: {
      base64: 'EACAAAWQ1awbplhYLsBHGrCAxAMIHjZkfKAAjAADaVB+kv8=',
    },
  },
  {
    key: '[Uniques]/Gloves/Souldrain',
    value: {
      base64: 'EACAAAUIBNoVfqofEb4HTnACBAQIeHgcfBzwOI0NSCD+Aw==',
    },
  },
  {
    key: '[Uniques]/Gloves/Steelrend',
    value: {
      base64: 'EACAAAXQFOIVpDuJe8bHYUgCBgUANBF48PjADUSK/w==',
    },
  },
  {
    key: '[Uniques]/Gloves/The Hand of Broc',
    value: {
      base64: 'EACAAAWI5K4byto4tb+HGXAAA4MENBAofKBAC2k8Bj4G/wE=',
    },
  },
  {
    key: '[Uniques]/Gloves/Venom Grip',
    value: {
      base64: 'EACAAAUQhN8V4N6T5MYHOnABAwMIoD6MoIU5FyVHJpmQ4VFAVPgP',
    },
  },
  {
    key: "[Uniques]/Helmets/Andariel's Visage",
    value: {
      base64:
        'EAiAAAUIBJIUQkQR6MdHVigFBYUA4APB0glVLRy6UDwUXVB/lOzh4sFssIiC4j8=',
    },
  },
  {
    key: "[Uniques]/Helmets/Biggin's Bonnet",
    value: {
      base64: 'EAiAAAUQRLwZBpq7uL3HEXgAA4M48CLBSwQPHiZ48AED/wE=',
    },
  },
  {
    key: "[Uniques]/Helmets/Blackhorn's Face",
    value: {
      base64: 'EAiAAAUAhJMUVM21hMTHMwgDBYWAwC3FtToBQDkSxRLlPw==',
    },
  },
  {
    key: '[Uniques]/Helmets/Coif of Glory',
    value: {
      base64: 'EAiAAAWQBF8bJuVDw8dHEsgABob4QAEQZFJcixMAdP4D',
    },
  },
  {
    key: '[Uniques]/Helmets/Crown of Ages',
    value: {
      base64: 'EAiAAAVYBB428KJJn4wPrAALGRgCQcYHUJC4dsJcCnMrzLUwN0b2J5j+Bw==',
    },
  },
  {
    key: '[Uniques]/Helmets/Crown of Thieves',
    value: {
      base64: 'EAiAAAWAhB82EMk5z4oPZ8AHGRkhIHdASoIhCMhOpOPBeILsPw==',
    },
  },
  {
    key: '[Uniques]/Helmets/Darksight Helm',
    value: {
      base64: 'EAiAAAUIhOMbpt8eicYHM7iCh4c4Ac9HIQtkmmw4wsCsQMjDwxr0Hw==',
    },
  },
  {
    key: '[Uniques]/Helmets/Duskdeep',
    value: {
      base64: 'EAiAAAUYRMY33I+nA44PJVACDw8BQYYFBAbEBw+IOE5cS3FtxbUW17IIKMR/',
    },
  },
  {
    key: '[Uniques]/Helmets/Giantskull',
    value: {
      base64: 'EAiAAAUIBGIX4hLzzr/HXjAECgoBMPRBKVECiBT/AQ==',
    },
  },
  {
    key: "[Uniques]/Helmets/Griffon's Eye",
    value: {
      base64: 'EAiAAAWQRPy2QbhwoEx8QAUeUEiID9JI0/oTpUacUvwH',
    },
  },
  {
    key: '[Uniques]/Helmets/Harlequin Crest(Shako)',
    value: {
      base64: 'EAiAAAUEBL4ZhKd5GMYHPrgEA4MAIBJAJEA0QERCGhTLP8LGZGP+Aw==',
    },
  },
  {
    key: '[Uniques]/Helmets/Howltusk',
    value: {
      base64: 'EAiAAAWYZGEbxvErGMIHE3ABCoqAAGWE4GQQJQAHJGf8Dw==',
    },
  },
  {
    key: "[Uniques]/Helmets/Kira's Guardian",
    value: {
      base64: 'ECiAAAQMRPyYsB1PKqQ9ygIPMjLEB0GccJjC4QqHLRxmOgb1Hw==',
    },
  },
  {
    key: "[Uniques]/Helmets/Nightwing's Veil",
    value: {
      base64: 'EAiAAAUEBGIbrOmajb7HVVAFyogQQIOAZ4uMnX9UKbE0yH8=',
    },
  },
  {
    key: '[Uniques]/Helmets/Peasent Crown',
    value: {
      base64: 'EAiAAAWIhL8ZLjPu/8dHMgACA4MIQBtAg0BGiQpm9Cf/AQ==',
    },
  },
  {
    key: '[Uniques]/Helmets/Rockstopper',
    value: {
      base64: 'EAiAAAUQhEszAKpXv4wPZZAECQkx4AWBGwlpJ/SlgLcC3hjZfw==',
    },
  },
  {
    key: '[Uniques]/Helmets/Stealskull',
    value: {
      base64: 'EAiAAAWQhF8bLHwVNb3HMpgCBoaAAI9HwUcBimUXzxjPfw==',
    },
  },
  {
    key: '[Uniques]/Helmets/Steelshade',
    value: {
      base64: 'EAiAAAUQBF4b0unNqsJHSgAFBoaAIMgHQgn8aPEf',
    },
  },
  {
    key: '[Uniques]/Helmets/Tarnhelm',
    value: {
      base64: 'EAiAAAUghKQZ5mqudccHEqiAhIR48gqK5Z/8Bw==',
    },
  },
  {
    key: '[Uniques]/Helmets/The Face of Horror',
    value: {
      base64: 'EAiAAAWgxJIUgqvZor+HE+AABYUAQPNhBCekpZC2QloLaXB+eoz8Bw==',
    },
  },
  {
    key: '[Uniques]/Helmets/Undead Crown',
    value: {
      base64: 'EAiAAAUAVBw2SGgybo+PJoADGRkBgccHGbTQx6Owpsjs1GOEDzn/AQ==',
    },
  },
  {
    key: '[Uniques]/Helmets/Valkiry Wing',
    value: {
      base64: 'EAiAAAUYhGMbYtmf+bxHM2gDCoqAgGwKBAY1BqWI8B8=',
    },
  },
  {
    key: '[Uniques]/Helmets/Vampiregaze',
    value: {
      base64: 'EAiAAAWYhGMXuuHlh8cHNEAECoqAQGYEReKaDQMLZDwQPhCaRv8B',
    },
  },
  {
    key: '[Uniques]/Helmets/Veil of Steel',
    value: {
      base64: 'ECiAAAQYBGIbLqr8MLVHPlAFCo84oS+FvhX6WuiDwAPAy4BXFkhC8cES/wE=',
    },
  },
  {
    key: '[Uniques]/Helmets/Wormskull',
    value: {
      base64: 'EAiAAAUIVLENzsvH++NjCbAABUUkUGkRLocZZiDjUZii/Ac=',
    },
  },
  {
    key: '[Uniques]/Jewels/Rainbow Facet(Fire)(Die)',
    value: {
      base64: 'EACAAAVIFd0AghGR0vH4kmKAEdGi2IcDOemNpgX/AQ==',
    },
  },
  {
    key: '[Uniques]/Jewels/Rainbow Facet(Fire)(Lvl)',
    value: {
      base64: 'EACAAAUQBN0AAqmRl17hgmOAEdHiWOcCOemNpgX/AQ==',
    },
  },
  {
    key: '[Uniques]/Jewels/Rainbow Facet(Cold)(Die)',
    value: {
      base64: 'EACAAAUQFN0AAkhGiZDgVmKwgWFioFi5A3npjacF/wE=',
    },
  },
  {
    key: '[Uniques]/Jewels/Rainbow Facet(Cold)(Lvl)',
    value: {
      base64: 'EACAAAVQBN0AAv/gnZfgQmOwgWFi4NjKAnnpjacF/wE=',
    },
  },
  {
    key: '[Uniques]/Jewels/Rainbow Facet(Lightning)(Die)',
    value: {
      base64: 'EACAAAVUFN0AAibUJJ/gFmKQEShR7K2BrPSG04L/',
    },
  },
  {
    key: '[Uniques]/Jewels/Rainbow Facet(Lightning)(Lvl)',
    value: {
      base64: 'EACAAAUUBN0AgswA41jgAmOQEShxLIWBrPSG04L/',
    },
  },
  {
    key: '[Uniques]/Jewels/Rainbow Facet(Poison)(Die)',
    value: {
      base64: 'EACAAAUcBN0AAjH47azg0mLIscsuMorNXJCZ3oBa8B8=',
    },
  },
  {
    key: '[Uniques]/Jewels/Rainbow Facet(Poison)(Lvl)',
    value: {
      base64: 'EACAAAVUBN0AArRoBeD4wmPIscsuMo5dFpGZ3oBa8B8=',
    },
  },
  {
    key: "[Uniques]/Rings/Bul Katho's Wedding Band",
    value: {
      base64: 'EACAAAUI9fzYcN4XpB++xBAWSPEo/Ak24j8=',
    },
  },
  {
    key: '[Uniques]/Rings/Carrion Wind',
    value: {
      base64: 'EACAAAXI9PzYgBH+EfS9oBdAgGrxj0dCjmKsgQeRTOFCwazy5uHhPw==',
    },
  },
  {
    key: '[Uniques]/Rings/Dwarf Star',
    value: {
      base64: 'EACAAAUA5PzYoHtILja+JBEOIFmAxOFhxPMEmaPHfw==',
    },
  },
  {
    key: '[Uniques]/Rings/Manald Heal',
    value: {
      base64: 'EACAAAWA5PzYQMNNJSO+kgcO0NhA4eOgxPwP',
    },
  },
  {
    key: '[Uniques]/Rings/Nagelring',
    value: {
      base64: 'EACAAAVA5PzYABLsZTy+gAcmLDFicDKAIvgf',
    },
  },
  {
    key: "[Uniques]/Rings/Nature's Peace",
    value: {
      base64: 'EACAAAWI9PzYoPYB9/K9xBJELC3MsVknwKwQZ2PjPw==',
    },
  },
  {
    key: '[Uniques]/Rings/Raven Frost',
    value: {
      base64: 'EACAAAVI9PzY8PjDHgW+MhEE0BIgTdDHxkMLMkqUTP8D',
    },
  },
  {
    key: '[Uniques]/Rings/Stone of Jordan',
    value: {
      base64: 'EACAAM0d4PzYINVmPDW+ogcS0MgIGGgy/sl/',
    },
  },
  {
    key: '[Uniques]/Rings/Wisp Projector',
    value: {
      base64: 'EACAAAUI9PzYwBKMXvW98ROg4EGiGINiUDATxHl4YFaw09DA7LBnYeE/',
    },
  },
  {
    key: '[Uniques]/Shields/Blackoak Shield',
    value: {
      base64: 'EAiAAAWABNob/JNO0L8HPzAElYuAgCxJixmjnckKJAjYlG6EuuI/',
    },
  },
  {
    key: '[Uniques]/Shields/Bverrit Keep',
    value: {
      base64: 'EAiAAAUAxPxBMBcbuA8fZIAEPDwCQAkEPBSUDygYUZyYmITsPw==',
    },
  },
  {
    key: "[Uniques]/Shields/Headhunter's Glory",
    value: {
      base64: 'EAiAAAUQBBIO5rGB8uLDMLBCqcR8cA0IryfMtYBn5fAf',
    },
  },
  {
    key: "[Uniques]/Shields/Kerke's Sanctuary",
    value: {
      base64: 'EAiAAAUAhP9BkJBr4Bwf5CALSEgCAjwKnghohHTCXApzK8y1MJeETEn7Hw==',
    },
  },
  {
    key: '[Uniques]/Shields/Lance Guard',
    value: {
      base64: 'EAiAAAUIhE8ppGQgHo+Pc5CFmxtxQAoEPE5eY2RynkaU/w==',
    },
  },
  {
    key: '[Uniques]/Shields/Lidless Wall',
    value: {
      base64: 'EAiAAAVAlRMO4/RNleHDHITCKEgEUEEQ1ITKUmlQf6Ko8B8=',
    },
  },
  {
    key: "[Uniques]/Shields/Medusa's Gaze",
    value: {
      base64: 'EAiAAAUYBP5BCDBbUfAeXYEVXDUCAq0VGHkkLFGKsTCQkx1bKP4D',
    },
  },
  {
    key: '[Uniques]/Shields/Mosers Blessed Circle',
    value: {
      base64: 'EAiAAAUYhNsbYIEK8sNHOBACEBCBwI1CdiJcinArwrUIZ0b2Hw==',
    },
  },
  {
    key: '[Uniques]/Shields/Pelta Lunata',
    value: {
      base64: 'EAiAAAUIRKEI5mlP7+DDC0SAgUEAEAmgGqCCgIIC9QEFSRjM8P4D',
    },
  },
  {
    key: "[Uniques]/Shields/Radimant's Sphere",
    value: {
      base64:
        'EAiAAAUghBsKaiQ7DOGjHKABikxAQEaBajExBzPMkElCYQaVrOCiwMyYAgXlPw==',
    },
  },
  {
    key: '[Uniques]/Shields/Spike Thorn',
    value: {
      base64: 'EAiAAAUYBE4pnHR1Qo6PteCKqSkBwRIJbkn0x8jcrf8=',
    },
  },
  {
    key: '[Uniques]/Shields/Spirit Ward',
    value: {
      base64: 'EAiAAAUgBBoKcvnSMOODLNSCjExAoEXBOwEvBbwV8FrAM9OqtEiGLFT4Dw==',
    },
  },
  {
    key: '[Uniques]/Shields/Steelclash',
    value: {
      base64:
        'EAiAAAUMRPqZoPc8COc9xkAHPDwEBDIUsg8eEDGcuJbi2oprLa4loZiyZDkzqP8=',
    },
  },
  {
    key: '[Uniques]/Shields/Stormchaser',
    value: {
      base64: 'EAiAAAUAlJ8VHtp2rceHOECCj4+AwG2CJRSoFPpkBDyY8diZzNiBkKyoh/Af',
    },
  },
  {
    key: '[Uniques]/Shields/Stormguild',
    value: {
      base64: 'EAiAAAUQ5J4VFtB7gcYHGMgABoaAwIOC9wEFI4IU4WQEBiR5ADT+Aw==',
    },
  },
  {
    key: '[Uniques]/Shields/Stormshield',
    value: {
      base64: 'EAiAAAUgBP5MEFE59xUf/YASVkECgA+FjMS6FOFWEDRzA6Qwteb9Bw==',
    },
  },
  {
    key: '[Uniques]/Shields/Swordback Hold',
    value: {
      base64: 'EAiAAAUYhKYUQEoSP8WHGCABCoqAwIMC9YECThSHZIwI/wE=',
    },
  },
  {
    key: '[Uniques]/Shields/The Ward',
    value: {
      base64: 'EAiAAAUgZBkKuhCjG+OjDLgABUUAUIFAhoLyQQYjhBP6Uuhboa+Fvv8=',
    },
  },
  {
    key: "[Uniques]/Shields/Tiamat's Rebuke",
    value: {
      base64:
        'EAiAAAUIlP9MGPvN+Pwe48AJTEwCArIT6VKkW5GuRToYI19kBHjY2KhhmQQlWcJCIdkBQyGZ4cPgPw==',
    },
  },
  {
    key: '[Uniques]/Shields/Umbral Disk',
    value: {
      base64: 'EAiAAAUAlOwNMxY1yeHjC1QAAkIIUB2gAUEGBe8DCpI8ZJE4gf8=',
    },
  },
  {
    key: '[Uniques]/Shields/Visceratuant',
    value: {
      base64: 'EAiAAAWYhEMROmebSMAHOOABEZGAYImCNyUxIwOk/gM=',
    },
  },
  {
    key: '[Uniques]/Shields/Wall of the Eyeless',
    value: {
      base64: 'EAiAAAUIVAmHbh686/ARBlKAgiIgoPhAgRbcfAzSoBQV/gM=',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Elite/Cranebeak',
    value: {
      base64: 'EAiAAAUA1NsZbDpNysXHX9DQEBFYspQRxATFsguPToYZ0s3Dw38=',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Elite/Deathcleaver',
    value: {
      base64: 'EAiAAAUI1IMX2FBXnMeHTtDQEBEwYrSS6MKjE2ok/A8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Elite/Ethereal Edge',
    value: {
      base64: 'EAiAAAUQ1OsLe1+hlOODKIyMiAi0aE3wqksrD7dFikcMTP8D',
    },
  },
  {
    key: "[Uniques]/Weapons/Axe/Elite/Executioner's Justice",
    value: {
      base64: 'EAiAAAXA1K9fQJN7pvAeO0FGRkQQKbKLjE4IUYaYcYXsPw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Elite/Hellslayer',
    value: {
      base64: 'EAiAAAXI1KsJsGY7mOHDH6CgiAM5IpAhA8NS3zDqBcU2jBvxjfgP',
    },
  },
  {
    key: "[Uniques]/Weapons/Axe/Elite/Messerschmidt's Reaver",
    value: {
      base64: 'EAiAAAXQ1K8XeuHZXsbHP5CREQBeArwEvAa8IiBDBoMCXpKMO3i2Uf8B',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Elite/Razoredge',
    value: {
      base64: 'EAiAAAUAxOMXbnQNWbyHSeDgEBHChevCoxM6JGsk+w8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Elite/Runemaster',
    value: {
      base64: 'EAiAAAUQxDMvyLmBBY6PnIDBoCI4dMiiZPof',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Exceptional/Boneslayer Blade',
    value: {
      base64: 'EAiAAAUAxK0XjEWVAMdHIpCREQBQInDj1gV150YyqgwZM6oMZGR6lD3lPw==',
    },
  },
  {
    key: "[Uniques]/Weapons/Axe/Exceptional/Butcher's Pupil",
    value: {
      base64: 'EAiAAAUIxD0epGhGt72HIMDAEBGQIavgWZB1kR3KNBph+h8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Exceptional/Coldkill',
    value: {
      base64: 'EAiAAAUQxOEXSpEvVMFHIODgEBF8+VpxjcWzgYJCpovMmNKCIlnBguI/',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Exceptional/Guardian Naga',
    value: {
      base64: 'EAiAAAUcxIEXrrB9e8FHIdDQEBFo0bJAaWEuB0AA6XPyMIZwUfgP',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Exceptional/Islestrike',
    value: {
      base64: 'EAiAAAUUxDEv0J5Z5nyPQYCBIQCoBFAJUA1QRfDlC4SMKdWadFmDL4gy/wE=',
    },
  },
  {
    key: "[Uniques]/Weapons/Axe/Exceptional/Pompe's Wrath",
    value: {
      base64: 'EAiAAAUA1NkZ4Kt4tr0HIdDQEBFUqYIxYilKwJLMGEIP4T8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Exceptional/Spellsteel',
    value: {
      base64:
        'EAiAAAUI1OkLzF2QdOPjEIyMiASEEUqV2pAx4tmCksbDLLCBgoLZcIWHBzOlDDIyZkw4PDz/AQ==',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Exceptional/Stormrider',
    value: {
      base64:
        'EAiAAAUQ1KkJkprhieIDEaCgiAhkyFwYMSxlBMgkkQH0jFEmKIwpNRSSFSY8/gM=',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Exceptional/The Minataur',
    value: {
      base64: 'EAiAAAXA1K1fsGpBoBgfikBGRgCgiYAM2QUKgyeOwE5EHkuy/w==',
    },
  },
  {
    key: "[Uniques]/Weapons/Axe/Exceptional/Warlord's Trust",
    value: {
      base64: 'EAiAAAXI1N0XlHqzH8aHIfDwEBFevfpQhRPSUkhbIa2FNCXyN4Jf9h8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Normal/Axe of Fechmar',
    value: {
      base64: 'EAiAAAUA5D4eMGbeyb1HAfDwEBG0aFmhL4sZGv8B',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Normal/Bladebone',
    value: {
      base64: 'EAiAAAUIhHk8fFRGwI8PAYCBISLIkPHBAzAQGHRB6cHDB5X/',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Normal/Brainhew',
    value: {
      base64: 'EAiAAAUQZD0eGKMI18cHApCREQlyIkCBcsGB8TDCRyML/gc=',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Normal/Deathspade',
    value: {
      base64: 'EAiAAAUY5PEhAAhBqnqPAIDhICIYMVIBiRO4M0IR4T8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Normal/Goreshovel',
    value: {
      base64: 'EAiAAAUgRB8Pw7HBV+PDAIyMCAA5EWTIwJDoIjvE+w8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Normal/Humongous',
    value: {
      base64: 'EAiAAAUAdP14KIL11RsfCUBGRgDwiYAHzwUEQ2YLHqLQfw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Normal/Rakescar',
    value: {
      base64: 'EAiAAAUIFDweNBEwNMcHAdDQEBEsWZogQwt9OQABZEkX2X8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Normal/Skull Splitter',
    value: {
      base64: 'EAiAAAUQ1M5fmExKRQ8fA0DDQUQgQ2YCGRsoZAQMxBEcevwH',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Normal/The Chieftan',
    value: {
      base64: 'EAiAAAXAVA0P55jwK+DjAKCgiAhkyJzgloLbCm4tuMkIUOiCUmT4Dw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Axe/Normal/The Gnasher',
    value: {
      base64: 'EAiAAAXIFD8eIuXL6sYHAODgEABQIhgxckiGiPIf',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Elite/Windforce',
    value: {
      base64: 'EAiAAAUIZH9BuOXr4h4fCuGGRABQEVCKoE8fBw8fiCiBLiht2X8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Exceptional/Cliffkiller',
    value: {
      base64: 'EAiAAAUIBLlISH0u7h4fwYCFRRyQEsGcuQsKBg8IKFECU6D/',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Exceptional/Endlesshail',
    value: {
      base64: 'EAiAAAUYBBEagO3EKcbHLyAhEQmQInDjBkLGinU2HjwsrdHQ/w==',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Exceptional/Godstrike Arch',
    value: {
      base64: 'EAiAAAUgBLkgHBed6YuPYXBzIyLo06dE7WK8oyoPNz3cjB15FP4D',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Exceptional/Kuko Shakaku',
    value: {
      base64: 'EAiAAAUAFLkaRL3AXsaHL+DgEBFo0YKBQmvNhnGSeTrwAgDYfw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Exceptional/Magewrath',
    value: {
      base64: 'EAiAAAUQFCEQaM37+8eHMIAxEQJUESxZmqDPhQyDbETj4zEFWWNhcQL/AQ==',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Exceptional/Riphook',
    value: {
      base64: 'EAiAAAUIFcEaCLgkbMdHLwABEQmGInDjxkPRRXbIY8nzHw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Exceptional/Skystrike',
    value: {
      base64: 'EAiAAAUQFSENvQjN/+KDF1BQiACqCMiQTSBDRqDPFKSLzJiBg+A/',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Exceptional/Whichwild String',
    value: {
      base64: 'EAiAAAUQFSEkdFYMC44PYICCQiKoUnUCXgp4K+C1gNeJYqwQQqAP+Q8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Normal/Blastbark',
    value: {
      base64: 'EAiAAAUA5AINKKhW3uNDCNzcCAAlEQQJ8jGYgqyBoP8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Normal/Hellclap',
    value: {
      base64: 'EAiAAAUIhIAGcs9Pe+8RBGBghABWBC1aJixxAh6MBxldPH6S/w==',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Normal/Pluckeye',
    value: {
      base64: 'EAiAAAUQhBQE+lRX7PGxAygoxAEVEciQmcCBj0EWUyT4Dw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Normal/Raven Claw',
    value: {
      base64: 'EAiAAAUY5CoI4D/9s+OjB3BwCAAjAkYRjBi5Y8TT4D8=',
    },
  },
  {
    key: "[Uniques]/Weapons/Bow/Normal/Rogue's Bow",
    value: {
      base64: 'EAiAAAUgRCgIjE1O7+PDB5CQiAg8eEzg4YS0FNJWSGshrYtRD55Gnv8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Normal/Stormstrike',
    value: {
      base64: 'EAiAAAUAlFSDkuqP5/j4ASgoAgBKBC1aJnCQIpyMwANOmf8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Normal/Witherstring',
    value: {
      base64: 'EAiAAAUIFCsI1ulcJ+GDB4CAiAgyZEyQ4UKAYdBF1mnwHw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Bow/Normal/Wizendraw',
    value: {
      base64: 'EAiAAAUQ9KqG8dXvTfABBFhYRIBXAp8IUKBMIGOFuC6oToGnI/8B',
    },
  },
  {
    key: '[Uniques]/Weapons/Crossbow/Elite/Gutsiphon',
    value: {
      base64: 'EAiAAAUAZH940PZawx0fJQEFRUTgxo2H5FDIUoZT6D8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Crossbow/Elite/Hellrack',
    value: {
      base64: 'EAiAAAUIZI95YPq7jfAeSEFGhkQwZw7GD1EZP1E2foiGdEHdUcVM2sDS8j8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Crossbow/Exceptional/Buriza-Do Kyanon',
    value: {
      base64: 'EAiAAAUABME8dHJqBX0PYyAjIwQMIyBD9gEUNkCIIXchGxqcyNqo/w==',
    },
  },
  {
    key: '[Uniques]/Weapons/Crossbow/Exceptional/Demon Machine',
    value: {
      base64: 'EAiAAAUQBDk8EOEQr4uPY4CCIhIQRdizZwKeGIQflsJJ6MnwHw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Crossbow/Exceptional/Langer Briser',
    value: {
      base64: 'EAiAAAUIFLk8kLcylY4PYuDhIQ74iIAMGQaPjIAaKKBRAodC/wE=',
    },
  },
  {
    key: '[Uniques]/Weapons/Crossbow/Exceptional/Pus Spiter',
    value: {
      base64: 'EAiAAAQAFbE8pIs8HWmPYoCCIiJw45YDGGCQTZG2oHTxGAu2ICQzuEiAU/4D',
    },
  },
  {
    key: '[Uniques]/Weapons/Crossbow/Normal/Doomslayer',
    value: {
      base64: 'EAiAAAUA5HANjgK/Q+PDCKCgiAMvIpAhMwXpIuM0+g8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Crossbow/Normal/Hellcast',
    value: {
      base64: 'EAiAAAUIBHMNqHpUGN6jCMjIiAhQoEww4sQ1FA/Gw4guKE+B/w==',
    },
  },
  {
    key: '[Uniques]/Weapons/Crossbow/Normal/Ichorsting',
    value: {
      base64: 'EAiAAAUQxHINFo24eOODCKCgCAG0CDJkTJAhhxlmLOmC4iT7Dw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Crossbow/Normal/Leadcrow',
    value: {
      base64: 'EAiAAAUY5HINzXFKoONjCHh4CAGqAyoiGDEyAYUW5hpl/gM=',
    },
  },
  {
    key: '[Uniques]/Weapons/Dagger/Elite/Fleshripper',
    value: {
      base64: 'EAiAAAUAxEsnQLd2cYUPmEBCIiKwZElHVidwSIYo0yhkifIf',
    },
  },
  {
    key: '[Uniques]/Weapons/Dagger/Elite/Ghostflame',
    value: {
      base64: 'EAiAAAUExOsNXfCEpN+jKby8iAjw4NFgY+PjkcXmxPQ/',
    },
  },
  {
    key: '[Uniques]/Weapons/Dagger/Elite/Wizardspike',
    value: {
      base64: 'EAiAAAUU1I8rqGWT54wPg6ABITY8nJiYYuKKiS0mNsnSGDHNBv0H',
    },
  },
  {
    key: "[Uniques]/Weapons/Dagger/Exceptional/Blackbog's Sharp",
    value: {
      base64: 'EAiAAAUAxEknLNVdw4UPVYDRICo8FlofeJCDPvr0dZGtSdI1U7iGCy3J/gM=',
    },
  },
  {
    key: '[Uniques]/Weapons/Dagger/Exceptional/Heart Carver',
    value: {
      base64: 'EAiAAAUExI2/sMbjODM+UgEFhYgAD16Fx8JozSCuccQ1ljhno9F/',
    },
  },
  {
    key: '[Uniques]/Weapons/Dagger/Exceptional/Spineripper',
    value: {
      base64: 'EAiAAAUIxI0r+J31eI8PVAABIQSoIsCDV+GxsOGBmKJ0Gc1ZJ/Af',
    },
  },
  {
    key: '[Uniques]/Weapons/Dagger/Exceptional/Stormspike',
    value: {
      base64: 'EAiAAAUMxOkNSrthQt9jFWBgiAiWLMkI8ABEkw0mZNAh/wE=',
    },
  },
  {
    key: '[Uniques]/Weapons/Dagger/Normal/Gull',
    value: {
      base64: 'EAiAAAUAZFwnaCfG+YSPEwABIRJsVAgsPKAg/wc=',
    },
  },
  {
    key: '[Uniques]/Weapons/Dagger/Normal/Spectral Shard',
    value: {
      base64: 'EEiAAAUIRO8YEGjeDMeHCsDAEAmkJtxwQloKaSuktZCWxvgf',
    },
  },
  {
    key: '[Uniques]/Weapons/Dagger/Normal/The Diggler',
    value: {
      base64: 'EAiAAAWAZPyd4GBgLzE+UAAFhRCgiiBDxolwK8J1kc35Hw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Dagger/Normal/The Jade Tan Do',
    value: {
      base64: 'EAiAAAUERDq/UOxV+Tw+UgAGhphgSYuTLmgO5pgjk+l/',
    },
  },
  {
    key: "[Uniques]/Weapons/Mace/Elite/Baranar's Star",
    value: {
      base64: 'EAiAAAUI1FsTkhyxhgoHQEBCEgBeBLwiIEMGIwCZjAAZGwHIJpOQdTHe4fYf',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Elite/Demonlimb',
    value: {
      base64: 'EAiAAAUA1NMMcPjuteMDJQQFiQjmzJ3gBsO7KY9GnkfMLhooKPgV/wE=',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Elite/Earthshifter',
    value: {
      base64: 'ECiAAAQA1C8bNggmZbRHYODhERFYshzmqJNBFOriYebQ4+HBSwXgaTz/AQ==',
    },
  },
  {
    key: "[Uniques]/Weapons/Mace/Elite/Horizon's Tornado Scourge",
    value: {
      base64: 'EAiAAAUA1Ms3uMlCJXsPmRAUJCJgxLgFqovREsXYUw/lPw==',
    },
  },
  {
    key: "[Uniques]/Weapons/Mace/Elite/Nord's Tenderizer",
    value: {
      base64: 'EAiAAAUM1IsbRDr6FsYHYLi5ERGUKrXRfLyvS+sOMkOC0oMZtAMDw38=',
    },
  },
  {
    key: "[Uniques]/Weapons/Mace/Elite/Schaefer's Hammer",
    value: {
      base64: 'EAiAAAQYxAMcAtAyM7RHQACIA1IiCBKUYqIMGZks1QVlTFGBog0CB/0H',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Elite/Stone Crusher',
    value: {
      base64: 'EAiAAAUQ1AMcTOIKrcbHTAgKEgB8IgAF+kYGnQweDiLUfw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Elite/Stormlash',
    value: {
      base64: 'EAiAAAQYxMs3GKA9MmgPtBAUJCKwZCkjyK6LDJBHFIqUGKao8Bgm1UP5Dw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Elite/The Cranium Basher',
    value: {
      base64:
        'EAiAAAXA1C8bDIOV+MaHQODhEQByIsCDd4HCQDkRLkW4FeFahOuCQrTE1FggBOE/',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Elite/Windhammer',
    value: {
      base64: 'EAiAAAUgxFsf2skTAcZHVOB5ERHMmesCRSQzZsET+g8=',
    },
  },
  {
    key: "[Uniques]/Weapons/Mace/Exceptional/Baezil's Vortex",
    value: {
      base64: 'EAiAAAUA1Mk3cMV+aIwPS+DhIRIQRkCGLEU4GYElXVDGEBgKzB4YoKD+Aw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Exceptional/Bloodtree Stump',
    value: {
      base64: 'EAiAAAUI1FkXJPdPf8IHJuDxEAByInDjdoJbCm4ruLXglgRlTaAhkvEKAdB/',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Exceptional/Dark Clan Crusher',
    value: {
      base64: 'EAiAAAUQ1Ikb5Bmjl8bHI8DAEBGGDZtS3WmRh9sepBY9/gM=',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Exceptional/Earthshaker',
    value: {
      base64: 'EAiAAAXA1AEcdHL/88fHJbi5ERFo0UoiEyXQRRYnwEsFYMYOdQr/AQ==',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Exceptional/Fleshrender',
    value: {
      base64: 'EAiAAAUU1NEMXtTJqN5jEpCQiAjIkFUYLciSUExp6gQOZRBRGlF4pQDoPw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Exceptional/Moonfall',
    value: {
      base64: 'EAiAAAUM1VkTBnUPIL9HJUBCEhEsWaqgWHiMWGDczMlixgwcCswWHHh4/gM=',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Exceptional/Sureshrill Frost',
    value: {
      base64: 'EAiAAAUI1dkXuEjRzL8HJeDhERFo0apQWFDY+IHTZ2hkyiwBQkbmPw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Exceptional/The Gavel of Pain',
    value: {
      base64: 'EAiAAAXQ1C0bgMfGIcZHJuDhERFAgbrAYPA40WBqLBCikCxgosAMEWJg4D8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Normal/Bloodrise',
    value: {
      base64: 'EAiAAAUAxJIJKxp0sOODAiAhiQh48PAoZLEunjVgdsfIocx/',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Normal/Bonesnap',
    value: {
      base64: 'EAiAAAUExD4YnI8VUMbHBeDhERFYsjxhboU5PUYQof4D',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Normal/Crushflange',
    value: {
      base64: 'EAiAAAUMxD4RVtXQL8fHBODhEQBeIvDgcUJflEAWQxT6Dw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Normal/Felloak',
    value: {
      base64: 'EAiAAAUQRFwNeaCp2d/DAWBgiAhQoJzgloIgDAMEUQL/AQ==',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Normal/Ironstone',
    value: {
      base64: 'EAiAAAUUBGAbbqSFp8eHBbi5EQBUIliyNMESGYEC/wE=',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Normal/Steeldriver',
    value: {
      base64: 'EAiAAAUcZNkXTsEXe8AHBuDhERH06eOQsUWmC+8/',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Normal/Stoutnail',
    value: {
      base64: 'EAiAAAUkhKYIdrI3HONDApCQiAGnCGTIjBCcKP4D',
    },
  },
  {
    key: '[Uniques]/Weapons/Mace/Normal/The Generals Tan Do Li Ga',
    value: {
      base64: 'EAiAAAUAVL4vULU9FY+PCuDhISLw4FEhsED5MAIfhS4oS7L/',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Elite/Bonehew',
    value: {
      base64: 'EAiAAAUIxP99yPUrKhofg0FGhkQACrSLrE7AGESFjJmjhIfHfw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Elite/Stormspire',
    value: {
      base64: 'EAiAAAUAxAMRzAWKHcMHQri5EQBUIujTl0KfjKCdLjJAG9NklAmCZEUNhf8=',
    },
  },
  {
    key: "[Uniques]/Weapons/Polearm/Elite/The Reaper's Troll",
    value: {
      base64: 'EAiAAAUIxBMSsCeV6sOHUQgKEhHgwbNBwOKAx2PL0pyNQsaCK0L/AQ==',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Elite/Tomb Reaver',
    value: {
      base64:
        'ECiAAAQAxM8XgAyw07WHSggKMl2gWTACRox69EGhPaEvhb4V+lro4+PdJgAUVhz/AQ==',
    },
  },
  {
    key: "[Uniques]/Weapons/Polearm/Exceptional/Athena's Wrath",
    value: {
      base64: 'EAiAAAUAxBESzF0rn8fHLAgKEgJeEWjRmtJ1kWFDtCH/AQ==',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Exceptional/Blackleach Blade',
    value: {
      base64: 'EAiAAAUIxO3+wTZjpWR8yAIZGRGBESMeiCyyZclYgURBm/If',
    },
  },
  {
    key: "[Uniques]/Weapons/Polearm/Exceptional/Grim's Burning Dead",
    value: {
      base64: 'EAiAAAUQxAER7nbAssKHLbi5ERAoRKBFa4I+J+rBGETnBDFF2yJDR/Yf',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Exceptional/Husoldal Evo',
    value: {
      base64: 'EAiAAAUYxGEXBsMvFsdHLbi5ERGQIZugzwUKA0iJ3AVVJ/Af',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Exceptional/Pierre Tombale Couant',
    value: {
      base64: 'ECiAAAQIxM0Xthpo6LUHLQgKEo1uU7gxMh+GCwwGSgRu3CYg8x8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Exceptional/The Meat Scraper',
    value: {
      base64: 'ECiAAAQAxKkPT33ThNojFsjIiAjIkHWR8VAckkHp4xUCsP8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Normal/Dimoaks Hew',
    value: {
      base64: 'EAiAAAUIRN8JoAKISeMDBsjICAGvCGTIfBBAF9R/',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Normal/Soul Harvest',
    value: {
      base64: 'EACAAAUAhAQqyP5yoIgPGRBEI0ApQo8eE1o4wS0FtxXcWnDzoTjk+Q8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Normal/Steelgoad',
    value: {
      base64: 'EACAAAUAdPeHYV4cx2l8xAAZERGMGJngwYlmKZqtaNaiWZIOON9Gnv8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Normal/The Battlebranch',
    value: {
      base64: 'EAiAAAUYZD4eJhG9s8bHDAgKEgJUEYwYmUAGj0MX2X8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Normal/The Grim Reaper',
    value: {
      base64: 'EACAAAUAFZAISWhrR+CjBtywiECBwoXHR6FOoBH5Pw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Polearm/Normal/Woestave',
    value: {
      base64: 'EAiAAAUgBL8b/vRTD8YHDbi5ERFQoMgScQZ1AnichsIhmSXZfw==',
    },
  },
  {
    key: "[Uniques]/Weapons/Scepter/Elite/Heaven's Light",
    value: {
      base64: 'EAiAAAUAxJMIrXd+wt5jLsjIkAgsWU7ZslwXFJ0QotAiyn8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Scepter/Elite/Ironward',
    value: {
      base64: 'EAiAAAUExAMKeA57nuODLxgZiQgiRYo4aEDB6+J5k+YON0QhSxleGAD8Dw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Scepter/Elite/The Reedeemer',
    value: {
      base64: 'EAiAAAUMxJMILxCaCeCjMMjIiAgsWU6ZstwWlDVluIYP3zCiE8rj8D8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Scepter/Exceptional/Hand of Blessed Light',
    value: {
      base64:
        'EAiAAAQAxAEKZ6EAv8RDEhgZiQigQFWgLLQ2PHzgwZQpC64pwzV5dAePMSKPwn8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Scepter/Exceptional/The Fetid Sprinkler',
    value: {
      base64: 'EAiAAAUIxG1S2JYV3hUfkYCHR0Tw5WsCMhUeC5kcmWVGZspkLIhCYSy4ovAf',
    },
  },
  {
    key: "[Uniques]/Weapons/Scepter/Exceptional/Zakarum's Hand",
    value: {
      base64: 'EAiAAAUMxJEIo6hr4+MDEsjIiAjcuG1Q4PDgA9FFtkaO1tjRnMaKHQz/AQ==',
    },
  },
  {
    key: '[Uniques]/Weapons/Scepter/Normal/Knell Striker',
    value: {
      base64: 'EAiAAAUAhMQMIhFb5uPjAcjIiAQvEaBAmTDCCW4tuCHK/Ac=',
    },
  },
  {
    key: '[Uniques]/Weapons/Scepter/Normal/Rusthandle',
    value: {
      base64: 'EAiAAAUEZJEIM6LrH94DAvDwiAg8eFQYLBxGBDwQU5Y1Z7bmzfRA+Q8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Scepter/Normal/Stormeye',
    value: {
      base64: 'EAiAAAUIBNAMhu6fhYIjAhgZiQh48MgIDLAxUGBJCbrGTdfY2Zo8+Q8=',
    },
  },
  {
    key: "[Uniques]/Weapons/Spear/Elite/Arioc's Needle",
    value: {
      base64: 'EAiAAAUYxNMJehTON+PDL3h4iAjmzOWYbDJ9XWRz/mEj2X8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Spear/Elite/Steelpillar',
    value: {
      base64: 'EAiAAAUAxE8flLyti8eHVcjIEBCgRCBIsEuLDgVRBtP/',
    },
  },
  {
    key: '[Uniques]/Weapons/Spear/Elite/Viperfork',
    value: {
      base64: 'EAiAAAUIxOsJtyhe9uNjKHBwiAjw4E3Qp4W+HE01pa+L0VgyxeM/',
    },
  },
  {
    key: '[Uniques]/Weapons/Spear/Exceptional/Hone Sundan',
    value: {
      base64: 'EAiAAAUAxJEJaRtrteLjFXBwmAjIkF2gMKAQtfgp/wE=',
    },
  },
  {
    key: '[Uniques]/Weapons/Spear/Exceptional/Kelpie Snare',
    value: {
      base64: 'EAiAAAUIxJkTPJ64fMZHKxgZEQBUItCidcHDIDuhz9ISm/If',
    },
  },
  {
    key: '[Uniques]/Weapons/Spear/Exceptional/Soulfeast Tine',
    value: {
      base64: 'EAiAAAUgxOkJZ6553+PDFXBwiAi+fE3Qh8fBxyHJwxYoTaj/',
    },
  },
  {
    key: '[Uniques]/Weapons/Spear/Exceptional/Spire of Honor',
    value: {
      base64: 'EAiAAAUYxE0XuFEiescHLMjIEBAyRECG7AKFAaVEznJjUHda8MIA2DzmPw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Spear/Exceptional/The Impaler',
    value: {
      base64: 'EAiAAAUA1NEJr9nQnuODFXh4iAiqVE2wpAtqjYOtmdA56wQOof4D',
    },
  },
  {
    key: '[Uniques]/Weapons/Spear/Normal/Bloodthief',
    value: {
      base64: 'EACAAAUIVQ8biKtHvsBHC+BwAEDlgI4IMmTwSBwa/Qc=',
    },
  },
  {
    key: '[Uniques]/Weapons/Spear/Normal/Lance of Yaggai',
    value: {
      base64: 'EAiAAAUAlKYJpUIXlOPDBXBwiBPXUlxbca3FNRkBD04QXXj/AQ==',
    },
  },
  {
    key: '[Uniques]/Weapons/Spear/Normal/Razortine',
    value: {
      base64: 'EAiAAAUQxJxfkP3hqhwfLGBkRAB4EYCKIENGFxkdmaXMfw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Spear/Normal/The Dragon Chang',
    value: {
      base64: 'EAiAAAUAleYJJkKrK+NjBXh4iAkjXFBgDBjIYnrw/Ac=',
    },
  },
  {
    key: '[Uniques]/Weapons/Spear/Normal/The Tannr Gorerod',
    value: {
      base64: 'EAiAAAUQdf6koGlE3jA+XkBGhjjgIwIZMhN4OHENxYNxYSPL/Qc=',
    },
  },
  {
    key: "[Uniques]/Weapons/Staff/Elite/Mang Song's Lesson",
    value: {
      base64: 'EAiAAAUAZA8ooFibiY4PoaChITYopJH9adMHpw9PH/4D',
    },
  },
  {
    key: "[Uniques]/Weapons/Staff/Elite/Ondal's Wisdom",
    value: {
      base64: 'EAiAAAQYZC8o0OelD2gPwjAyIgJIP8BoBFLlRprgH/4H',
    },
  },
  {
    key: '[Uniques]/Weapons/Staff/Exceptional/Chromatic Ire',
    value: {
      base64: 'EAiAAAUABBEUdOwQo8RHLhgZESe4peC2glsLbkzCKVka1JoeWfMja4IEEP0P',
    },
  },
  {
    key: '[Uniques]/Weapons/Staff/Exceptional/Razorswitch',
    value: {
      base64: 'EAiAAAUEBCEKJhnnbOHjFlBQiANwEjyPeE7oS6Fvhb4W+pw80sj+5D8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Staff/Exceptional/Ribcracker',
    value: {
      base64: 'EAiAAAUIBLkU6M2j0rwHLvDwEAJeEMhEoEjxgoch+MENSci6GMcYEcn+Aw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Staff/Exceptional/Skullcollector',
    value: {
      base64: 'EAiAAAUMBAEU0Dx9+sfHLpCREU28P1JEgYf8Bw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Staff/Exceptional/Warpspear',
    value: {
      base64: 'EAiAAAUUBFEKHyonauNDF6CgCBD6pmRrVmyNja3RsTn/Aw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Staff/Normal/Bane Ash Short Staff',
    value: {
      base64: 'EAiAAAUAhMgEOanPlPBhAygoRAKfCDx4nNAHg8BAF9QaEl1TQv8B',
    },
  },
  {
    key: '[Uniques]/Weapons/Staff/Normal/Serpent Lord Long Staff',
    value: {
      base64: 'EAiAAAUE5JIJ06FVkuPjBnh4iAQqEVCgaKEvBwooLPFBzjJ0ZP8B',
    },
  },
  {
    key: '[Uniques]/Weapons/Staff/Normal/Spire of Lazarus Gnarled Staff',
    value: {
      base64: 'EAiAAAUIRJAJqDNUYeADB4yMiACvDSsiihQTZQQcTEnWqNiaGFpTI/8B',
    },
  },
  {
    key: '[Uniques]/Weapons/Staff/Normal/The Iron Jang Bong War Staff',
    value: {
      base64: 'EAiAAAUMBJAJpZyALd5DB8jIiAhkyHxAwZQoDWoNi61xoTUwdMfIfw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Staff/Normal/The Salamander Battle Staff',
    value: {
      base64: 'EAiAAAUURMkEHjoGve+RA1BQxAlzMB5ArCmxNS+0Zkb8RP8B',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Elite/Azurewrath',
    value: {
      base64:
        'EAiAAATQ1IsTml0xCrRHBwAIACoBVAJUA1QRHDqkoU/fhj79vizXRfYnl+60/w==',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Elite/Bloodmoon',
    value: {
      base64: 'EAiAAAUA1JMGhRCwy/EREkBARASCBHk8rDQOyZg9VSQk/Ac=',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Elite/Djinnslayer',
    value: {
      base64: 'EAiAAAUE1JMNYHgwhd9DJFhYkAjw4MHQp+/DkEfVHtYiHf4D',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Elite/Doombringer',
    value: {
      base64: 'EAiAAAUI1KsPpCvjXOODIKCgiAj69FXwLJAveBjIPA5MvDs8MDU2IIH4Dw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Elite/Flamebellow',
    value: {
      base64: 'EAiAAAUM1C8KSN++aN8jLMjICAA0A1QR4MGDkS4+TArJT+bIYwwKh/Ef',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Elite/Frostwind',
    value: {
      base64: 'EAiAAAUQ1F8Knlvrmd6jLbCwiAjmzNloN2/ZpRXGnGOnIULp8R8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Elite/Lightsabre',
    value: {
      base64:
        'EAiAAAXA1IsTwK5isMfHQACICMiQVVAseGQEyNDgwePjkGW7oOaElBlG1VD4Dw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Elite/The Grandfather',
    value: {
      base64: 'EAiAAAUIxK8xiJfkuY6PgiADIwDQBKAJoA2gHYATQZ++O0Yw1Ub9Bw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/Bing Sz Wang',
    value: {
      base64: 'EAiAAAUIxAkbXkkqYMbHKJCREQBoIoACZUOG0dIWI0PC2ABE4T8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/Blade of Ali Baba',
    value: {
      base64: 'EAiAAAUMxMki3O9J8oePTgACQgS8ErxEwIPnHQUP+Q8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/Bloodletter',
    value: {
      base64: 'EAiAAAUQxBEF+G8ne/GhCTBsRARGjCZoUYGx0OKBSOLRBbXmD9dcmibPfw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/Cloudcrack',
    value: {
      base64:
        'EAiAAAUUxKkLo2ByUOOjFKCgiAjIkH1AgQolI4AniwF6vDIAxEsDQMaOPAz/AQ==',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/Coldsteel Eye',
    value: {
      base64: 'EAiAAAUYxJENPO0d1+NjE1ggiQj69PkwJJHpgooTaCSz5PkP',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/Crainte Vomir',
    value: {
      base64: 'EAiAAAUcxDE47CpRuI0PUcDCIiIgQ0ZCWhcjGBQenaXRfw==',
    },
  },
  {
    key: "[Uniques]/Weapons/Sword/Exceptional/Ginther's Rift",
    value: {
      base64: 'EAiAAAUgxIkTYKutocKHJ6DgEREsWRrB0JDBkwSli4wf9R8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/Headstriker',
    value: {
      base64: 'EAiAAAUA1CmFxcmovPHxCUBABICXCJYs1QloQ/Qx/wE=',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/Hexfire',
    value: {
      base64: 'EAiAAAUI1JEGskolrvHBCUBARARQoCqMFlAnwqFQc/rJmBk+kJD8Bw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/Plague Bearer',
    value: {
      base64: 'EAiAAAUM1F0KcCoFU94DFLCwiAiWLFVQLLRa1MsBGGDI1rirMYKLwn8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/Swordguard',
    value: {
      base64:
        'EEiAAAXA1K0xhM38tIyPUyAjIyLQokWBAkEmBPIJbim4reDWgtsWmTEoOZ419D8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/The Atlantian',
    value: {
      base64: 'EAiAAAXI1IExBBrNe3yPUMACKQDACGANQEXQp+9DFZKQTZnuGPkP',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/The Vile Husk',
    value: {
      base64: 'EAiAAAXM1C0KjcKWEeKDFMjIiAjIkLXQl0M11SwZC4Qw0OPtUf8B',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Exceptional/Todesfaelle Flamme',
    value: {
      base64:
        'EAiAAAXQ1MkakLc048OHKZCRERFAgToBD4YMskeKYcYLCmbKDBQUzBQaWlr+Aw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Normal/Blacktongue',
    value: {
      base64: 'EAiAAAUARAkEDIFzLfFBAlBQRAQePCbI0EJfDmCAsVQn8B8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Normal/Blood Crescent',
    value: {
      base64: 'EAiAAAUEhIQNSUvBS95DA1hYiAMvIkCBcuJaimsrrrW4xuORBbuMDoX+Aw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Normal/Culwens Point',
    value: {
      base64: 'EAiAAAUIBNAY1lydTscHCGBhERGgQJnAQxfUGJQboz/5Dw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Normal/Gleamscythe',
    value: {
      base64: 'EAiAAAUMRL4iKCD+JYYPDgACIhL4RCBD5oMHbAwUkMlyXVD/AQ==',
    },
  },
  {
    key: "[Uniques]/Weapons/Sword/Normal/Griswold's Edge",
    value: {
      base64: 'EAiAAAUQRGkMfDRAb+LDA4CACAAsEfDgmUAGDIYMUQJdPP8B',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Normal/Hellplague',
    value: {
      base64: 'EAiAAAUY5NIY0JzRDr/HB2BhERGgQIGRsSQHDGBY4lHwUfAT/Qc=',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Normal/Kinemils Awl',
    value: {
      base64: 'EAiAAAUgZP0owJqP9H+PESAjIxLQRCBDZoIlMAxQrDHj/w==',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Normal/Ripsaw',
    value: {
      base64: 'EAiAAAUAVL4aNmus1sZHCZCRERHIkLHwwPDwYTgE/Q8=',
    },
  },
  {
    key: "[Uniques]/Weapons/Sword/Normal/Rixot's Keen",
    value: {
      base64: 'EAiAAAUkhGgMUHclbOAjA2BgiAhkyFQoPowgi91BgSjzHw==',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Normal/Shadowfang',
    value: {
      base64: 'EAiAAAUIlMEU7OixYsZHCGBhERHIkFnBzYaCB0seCR+JLPIf',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Normal/Skewer of Krintiz',
    value: {
      base64: 'EAiAAAUMlPQEg/7WivCxAUBABAAVAaoIMmRUGCwcfBzm/A8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Normal/Soulflay',
    value: {
      base64: 'EAiAAAUQVFwbTDmL68eHCJCRERHIkDnRLEWzFc1aNONB8KHo4vkP',
    },
  },
  {
    key: '[Uniques]/Weapons/Sword/Normal/The Patriarch',
    value: {
      base64: 'EAiAAAUAddEYVuYK58GHCZCREQBUIuDBI2IYMTxBFifwHw==',
    },
  },
  {
    key: "[Uniques]/Weapons/Throw/Elite/Demon's Arch",
    value: {
      base64: 'ECCAAAQAxJMPMNg3fNqDKjg4UBBBmjQY6EN5MPopXWQyrqb+Aw==',
    },
  },
  {
    key: "[Uniques]/Weapons/Throw/Elite/Gargoyle's Bite",
    value: {
      base64: 'EACAAAUAxBsKT5Ak4+IDKEhIgBLBnLkcLLGkj8eD2ZIBD08/7z8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Throw/Elite/Gimmershred',
    value: {
      base64: 'EACAAAUExJsX2OxZlcfHU3h4AC+CNGkwtMfL6OqzAduYrIvMH89/',
    },
  },
  {
    key: '[Uniques]/Weapons/Throw/Elite/Lacerator',
    value: {
      base64: 'EACAAAUIxCsSwJAvX8dHUICAsCaCNGldZHB+dQKHQsYGIUL9sv8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Throw/Elite/Warshrike',
    value: {
      base64: 'EACAAAUQxKsUppTDvr4HSaCggCyCPn1dZI1knGTGEhgy/bz/',
    },
  },
  {
    key: '[Uniques]/Weapons/Throw/Elite/Wraithflight',
    value: {
      base64: 'EADAAAUUxK8bGEBPe8aHYICAsCSCL188Gooe/dD/',
    },
  },
  {
    key: '[Uniques]/Weapons/Throw/Exceptional/Deathbit',
    value: {
      base64: 'EACAAAUAxBkpuFZRd4mPkWBgAFQEWrQmCMcj4cPQCNUv+w8=',
    },
  },
  {
    key: '[Uniques]/Weapons/Throw/Exceptional/The Scalper',
    value: {
      base64: 'EACAAAUExJkXpIN36sIHSHh4ICgCMmQ8DF1Qd1ocCiki9PP+Aw==',
    },
  },
  */
  {
    key: '[Charms]/Grand Charm/Amazon/Bow and Crossbow+Life',
    value: {
      base64: 'EACAAAQIVNhtYPmXxBtTcI1UHEDCCwAg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Amazon/Javelin and Spear+Life',
    value: { 
      base64: 'EACAAAQEVNhtEEr3yB7TgI1UHEDCSwAg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Amazon/Passive and Magic+Life',
    value: {
      base64: 'EACAAAQAVNhtcMfPpBhTeY1UHEDCKwAg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Assassin/Martial Arts+Life',
    value: {
      base64: 'EACAAAQUVNhtKOePlh1TwI9UHEDCSwYg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Assassin/Shadow Disciplines+Life',
    value: {
      base64: 'EACAAAQQVNhtcHGb1h5TuI9UHEDCKwYg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Assassin/Traps+Life',
    value: {
      base64: 'EACAAAQMVNhtYHSrZhnTsI9UHEDCCwYg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Barbarian/Combat+Life',
    value: {
      base64: 'EACAAARAVdht2OjLkRvT8I5UHEDCCwQg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Barbarian/Warcries+Life',
    value: {
      base64: 'EACAAARIVdhtEEoXFRjTAI9UHEDCSwQg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Barbarian/Masteries+Life',
    value: {
      base64: 'EACAAAREVdhtmK7YdBxT+Y5UHEDCKwQg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Druid/Elemental+Life',
    value: {
      base64: 'EACAAARUVdhtIPe2xR5TYY9UHEDCSwUg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Druid/Shapeshifting+Life',
    value: {
      base64: 'EACAAARQVdhtACNGzRjTWI9UHEDCKwUg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Druid/Summoning+Life',
    value: {
      base64: 'EACAAARMVdhteBvD4RpTUY9UHEDCCwUg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Necromancer/Poison and Bone+Life',
    value: {
      base64: 'EACAAAQERNhtCOGCHhhTOY5UHEDCKwIg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Necromancer/Curses+Life',
    value: {
      base64: 'EACAAAQARNht6IenohpTMY5UHEDCCwIg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Necromancer/Summoning+Life',
    value: {
      base64: 'EACAAAQIRNht+CCP+RnTQI5UHEDCSwIg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Paladin/Combat+Life',
    value: {
      base64: 'EACAAAQMRNhtEPs+jx9TkI5UHEDCCwMg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Paladin/Defensive Auras+Life',
    value: {
      base64: 'EACAAAQURNhtAHTfTRhToY5UHEDCSwMg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Paladin/Offensive Auras+Life',
    value: {
      base64: 'EACAAAQQRNhtQNniPhlTmI5UHEDCKwMg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Sorceress/Cold+Life',
    value: {
      base64: 'EACAAAQgRNhtqCloJR5T4I1UHEDCSwEg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Sorceress/Fire+Life',
    value: {
      base64: 'EACAAAQYRNhtAC405x9T0I1UHEDCCwEg/wE=',
    },
  },
  {
    key: '[Charms]/Grand Charm/Sorceress/Lightning+Life',
    value: {
      base64: 'EACAAAQcRNhtmJRFGRhT2Y1UHEDCKwEg/wE=',
    },
  },
  {
    key: '[Charms]/Small Charms/3 20 20 Charm',
    value: {
      base64: 'EACAAARARNhP4OGZAR7TAEhXHKAxgQILAwwDUIP/',
    },
  },
  {
    key: '[Charms]/Small Charms/Cold dmg',
    value: {
      base64: 'EACAAATIRNhPOK3bahpTiVOw2HjoIPMf',
    },
  },
  {
    key: '[Charms]/Small Charms/Fire dmg',
    value: {
      base64: 'EACAAASIRNhP0LmkXhpT6FOzwNBQ8R8=',
    },
  },
  {
    key: '[Charms]/Small Charms/Life Mana',
    value: {
      base64: 'EACAAASARNhPINdJXR/TeElXHKCRIOY/',
    },
  },
  {
    key: '[Charms]/Small Charms/Life Res',
    value: {
      base64: 'EACAAARQRNhPGO4hiR5TeUpWHKBxolmKZiuatWj2Hw==',
    },
  },
  {
    key: '[Charms]/Small Charms/Light dmg',
    value: {
      base64: 'EACAAAQIRNhPoJARyx1TSVS2yBDG+A8=',
    },
  },
  {
    key: '[Charms]/Small Charms/MF Res',
    value: {
      base64: 'EACAAAQERNhPoPFzThxTEMpInGiWotmKZi2aQVn7Dw==',
    },
  },
  {
    key: '[Charms]/Small Charms/Poison dmg',
    value: {
      base64: 'EACAAAQARNhPyJCp6htTqVSt5BhppH//AQ==',
    },
  },
  {
    key: '[Craft]/Amulet/Armageddon Slippers',
    value: {
      base64: 'ECCAAAQY5FkY2Hrb0LQYgN0AUyYANAJiB7Yk0DrBLQW3FdxacOMy+g8=',
    },
  },
  {
    key: '[Craft]/Amulet/Gale Shell',
    value: {
      base64: 'ECCAAAQk5FkY3G3dbrQYdC8BU6gBNB4HH4cT3FJwW8GtBbcU+bjM/gM=',
    },
  },
  {
    key: '[Craft]/Amulet/Shadow Wing II',
    value: {
      base64: 'EACAAAUI9FkYli0JY8Q4UK+6ox30iLRwgMaECUQQNgIKyPAQQHEDw/kP',
    },
  },
  {
    key: '[Craft]/Amulet/Shadow Wing',
    value: {
      base64: 'EACAAAUE9FkYYNgj0MUYUK/+Jz1+pR8gQHYgxohhxTQeAjAaXjIA+Q8=',
    },
  },
  {
    key: '[Craft]/Amulet/Storm Circlet',
    value: {
      base64: 'ECCAAASY5FkYgnti/bQYUn0AUyIAMmlQB64k2DrxbcW3FN+mSFww/wE=',
    },
  },
  {
    key: '[Craft]/Amulet/Storm Hide',
    value: {
      base64: 'ECCAAATY5FkYWHAu3bQYUo0AUywANAJiB7Yk0DrBLQW3FdxacONi/A8=',
    },
  },
  {
    key: '[Craft]/Boots/Bitter Brogues Leather Boots',
    value: {
      base64: 'ECCAAASQ5KoJ3Bfyz1pDmA3QAAYGYGQAZAS0VrBLMe+EOC6t/w==',
    },
  },
  {
    key: '[Craft]/Boots/Grim Spur Chain Boots',
    value: {
      base64: 'ECCAAAQAxKoJmS6pc1qjtAwwAQgIYGRjUABmVtRL4a1FNy6p/w==',
    },
  },
  {
    key: '[Craft]/Boots/Rune Slippers Plate Boots',
    value: {
      base64: 'ECCAAASIBKsJXjoHNlpD1Q2QAQwMYGQAWAScVsBLAe/EPC6u/w==',
    },
  },
  {
    key: '[Craft]/Boots/Soul Shank Plate Boots',
    value: {
      base64: 'ECCAAAQIBKsJgcPAb1qDlwyQAQwMYGQAYgSQVtxLUe9EPi6W/w==',
    },
  },
  {
    key: '[Craft]/Boots/Soul Spur Heavy Boots',
    value: {
      base64: 'ECCAAASAZKcmjFr0v2oN3jIABBwcgJFByABgRoBrBbkU97i0/gM=',
    },
  },
  {
    key: '[Craft]/Boots/Viper Trample Chain Boots',
    value: {
      base64: 'ECCAAAQQxKoJ0cMVx1rjcw0wAQgIYGRjUAJaK96dcNfiGpfWfw==',
    },
  },
  {
    key: '[Craft]/Glove/Bow Blood Touch',
    value: {
      base64: 'ECCAAAUAlO9W0M9rxSEiomE5c0ZlUxVogYODA0hamONh6IJCpOAFACAAL/8B',
    },
  },
  {
    key: '[Craft]/Glove/Java Blood Touch',
    value: {
      base64: 'ECCAAAUIlO9WoEB8siUiomE5c0ZlUxVogYODA0hamONh6IJCpOAlACAAL/8B',
    },
  },
  {
    key: '[Craft]/Glove/Martial Arts Blood Touch',
    value: {
      base64: 'ECCAAAUQlO9WaObAjSYiomE5c0ZlUxVogYODA0hamONh6IJCpOAlAyAAL/8B',
    },
  },
  {
    key: '[Craft]/Glove/Passive Gale Grasp',
    value: {
      base64: 'ECCAAARAFNoVrqFbkrWI7hegCRAQuFiMESwUuqB4DHwMogScHHgFAOg/',
    },
  },
  {
    key: '[Craft]/Glove/Soul Touch',
    value: {
      base64: 'ECCAAAQIFO5WyFY5WtAivGGAJTg44MLoguIx8DFAVACQcqBFim7/AQ==',
    },
  },
  {
    key: '[Craft]/Ring/Beast Master',
    value: {
      base64:
        'EACAAAUA9PzYgLbFqyXGxCnZHU+zKcoEACMHXiSgmUDBCWYpmK1g1oIZj0GywgTHfw==',
    },
  },
  {
    key: '[Craft]/Ring/Bone Gyre',
    value: {
      base64: 'EACAAAVA9PzYUM1IQCPGYAp4HvvSMJUCADIHjkw4IwU2HoL/',
    },
  },
  {
    key: '[Craft]/Ring/Death Knot',
    value: {
      base64:
        'EACAAAWM9PzYUPtSySfGcJpXLsnhaVwJACIBQgdmVBAuCCe48RB8EpIVJjj+Aw==',
    },
  },
  {
    key: '[Craft]/Ring/Doom Loop',
    value: {
      base64: 'ECCAAAXA9PzYUMrgNy/GQLrXKxuyMCoEACQHXqSAtqIZj4CSMUv9Bw==',
    },
  },
  {
    key: '[Craft]/Ring/Havoc Band',
    value: {
      base64: 'EACAAIwZ4PzYoE5EqCnGEBzYAMXQAJFQCJ8AwIsA2oEwJ6SluNYiHA+FD8N/',
    },
  },
  {
    key: '[Craft]/Ring/Shadow Circle',
    value: {
      base64: 'EACAAAVE9PzYwMQoKizGgKoXJsfiupwDACIHZCQgERHwOPgw/Ac=',
    },
  },
  {
    key: '[Craft]/Ring/Skull Whorl',
    value: {
      base64: 'ECCAAAWQ9PzYAAPJ2SbGEyoYMecQJm0BACIHZCQYERGk8MZDYOd/',
    },
  },
  {
    key: '[Craft]/Ring/Storm Eye',
    value: {
      base64: 'EACAAAWA9PzY8MPubCXGkcrXMF1hPiQLACMCXAdYpMjG45DG8x8=',
    },
  },
  {
    key: '[Craft]/Ring/Storm Master',
    value: {
      base64:
        'EACAAAUM9PzY8Lm9viXGkCr5HYchOfQLADMHVEzAoMJgIXBhwBDgEfg0gAr8Bw==',
    },
  },
  {
    key: '[Jewels]/10 MF 40 Ed(red)',
    value: {
      base64: 'EACAAAQcBN0AAv0NjdaYkjFIIgIKFFDc/gM=',
    },
  },
  {
    key: '[Jewels]/10 Min 15 AllRes(red)',
    value: {
      base64: 'EACAAARYBN0AgtomGuSYUlTSoYJyQTlxLcW1FddaXPuk/Ac=',
    },
  },
  {
    key: '[Jewels]/10 Min 40 Ed(orange)',
    value: {
      base64: 'EACAAASkBN0AAgcBw/6YijHSIQIKFBWUC8on5T8=',
    },
  },
  {
    key: '[Jewels]/10-15 Dmg(red)',
    value: {
      base64: 'EACAAARIBN0AgvbeoNSYUi7SoYJi4XFBwfD4pIB6/Ac=',
    },
  },
  {
    key: '[Jewels]/15 IAS(green)',
    value: {
      base64: 'EACAAAXIEN0Awilg+ACODgBWocvoPw==',
    },
  },
  {
    key: '[Jewels]/15 IAS 15 AllRes(blue)',
    value: {
      base64: 'EACAAAQYBN0AwuxN4vCYRlRW4cS1FNdWXGtxrcvoPw==',
    },
  },
  {
    key: '[Jewels]/15 IAS 30 Fire AllRes(red)',
    value: {
      base64: 'EACAAATEBN0AgnMV8tOY0ilWocvohLn/',
    },
  },
  {
    key: '[Jewels]/15 IAS 40 Ed(green)',
    value: {
      base64: 'EACAAAUABN0Awilg+ACODgBWocsoAgoU/wE=',
    },
  },
  {
    key: '[Jewels]/15 IAS 8 Min(red)',
    value: {
      base64: 'EACAAASIBN0AgnMV8tOY0ilWoQJyAeky+oT8Bw==',
    },
  },
  {
    key: '[Jewels]/15 Max 40 Ed(green)',
    value: {
      base64: 'EACAAARkBN0AwtQlCcqYjjG8IQIKFBYeGB6gHv8B',
    },
  },
  {
    key: '[Jewels]/15 Req 15 AllRes(orange)',
    value: {
      base64: 'EACAAATUBN0AAomY1dCYSlTm4sS1FNdWXGtxbUvVfw==',
    },
  },
  {
    key: '[Jewels]/15 Req 40 Ed(orange)',
    value: {
      base64: 'EACAAATgBN0AAk/VwPyYijHmIgIKFFuq/gM=',
    },
  },
  {
    key: '[Jewels]/15 AllRes 1-100 Light(pink)',
    value: {
      base64: 'EACAAASYBN0AArB2AMiYQlQ45cS1FNdWXGtxTUZAxn8=',
    },
  },
  {
    key: '[Jewels]/15 AllRes 10 MF(red)',
    value: {
      base64: 'EACAAAQQBN0AgmMncu2YUlRI4sS1FNdWXGtxDYrbfw==',
    },
  },
  {
    key: '[Jewels]/20 Life 40 Ed(yellow)',
    value: {
      base64: 'EACAAARgBN0AwqL6pdCYljG+4gCNCChQ/Ac=',
    },
  },
  {
    key: '[Jewels]/40 Ed 1-100 Light(orange)',
    value: {
      base64: 'EACAAATkBN0AAreG29qYijE4JQIKFDICMv4D',
    },
  },
  {
    key: '[Jewels]/Fire Dmg 15 AllRes(green)',
    value: {
      base64: 'EACAAATYBN0AQt+IjuaYTlQ05cS1FNdWXGtxDUaGjP8=',
    },
  },
  {
    key: '[Jewels]/Fire Dmg 40 Ed(pink)',
    value: {
      base64: 'EACAAAQgBN0AAqz9zN6YgjE0JQIKFDAyZPwH',
    },
  },
  /*
  {
    key: '[Misc]/Misc/Arrows',
    value: {
      base64: 'ECCAAARE5G3ugjBO3Kt2CK//AQ==',
    },
  },
  {
    key: '[Misc]/Misc/Bolts',
    value: {
      base64: 'ECCAAARIRGzuwtZRBI12CH3/AQ==',
    },
  },
  {
    key: '[Misc]/Misc/Identify Book',
    value: {
      base64: 'ECCAAASA5KdSEBHwvtQKAYX/',
    },
  },
  {
    key: '[Misc]/Misc/Identify Scroll',
    value: {  base64: 'ECCgAASM5Eci' },
  },
  {
    key: '[Misc]/Misc/Skeleton Key',
    value: {
      base64: 'EACAAAXcRBpQ4WX+DDssYPAf',
    },
  },
  {
    key: '[Misc]/Misc/Town Portal Book',
    value: {
      base64: 'ECCAAAQAxKgULDvEaLQCQOE/',
    },
  },
  {
    key: '[Misc]/Misc/Town Portal Scroll',
    value: {  base64: 'ECCgAARMxJAI' },
  },
  {
    key: '[Misc]/Potions/Antidote Potion',
    value: {  base64: 'ECCgAAQABDUp' },
  },
  {
    key: '[Misc]/Potions/Full Rejuv Potion',
    value: {  base64: 'ECCgAATE5OxuAA==' },
  },
  {
    key: '[Misc]/Potions/Greater Healing Potion',
    value: {  base64: 'ECCgAARABE+0AA==' },
  },
  {
    key: '[Misc]/Potions/Greater Mana Potion',
    value: {  base64: 'ECCgAARExE60AA==' },
  },
  {
    key: '[Misc]/Potions/Rejuv Potion',
    value: {  base64: 'ECCgAATA5Owo' },
  },
  {
    key: '[Misc]/Potions/Stamina Potion',
    value: {  base64: 'ECCgAAQEZDcp' },
  },
  {
    key: '[Misc]/Potions/Thawing Potion',
    value: {  base64: 'ECCgAAQIBFgK' },
  },
  {
    key: '[Misc]/Quest/Act 1/Inifuss Scroll',
    value: {  base64: 'EACgAAUIRCVK' },
  },
  {
    key: '[Misc]/Quest/Act 1/Malus',
    value: {
      base64: 'EACAAAWkBI82QA559RiP/3fjgqz/AQ==',
    },
  },
  {
    key: "[Misc]/Quest/Act 1/Wirt's Leg",
    value: {
      base64: 'EAiAAAUc5A4rePe7nDEFQiaGrP8B',
    },
  },
  {
    key: '[Misc]/Quest/Act 2/Amulet',
    value: {
      base64: 'EACAAAWMZPeb4Zwb1HZ6YQ8cUJFApUU4sv4H',
    },
  },
  {
    key: '[Misc]/Quest/Act 2/Book of Skill',
    value: {  base64: 'ECCgAAQA5BEF' },
  },
  {
    key: '[Misc]/Quest/Act 2/Cube',
    value: {
      base64: 'EACAAAUARP884H4xhzYE/wE=',
    },
  },
  {
    key: '[Misc]/Quest/Act 2/Staff',
    value: {
      base64: 'EACAAAUQxJIcxjTZaqoHH2hZcUJaCmkrpLWQ1sVI1v8=',
    },
  },
  {
    key: '[Misc]/Quest/Act 3/Brain',
    value: {  base64: 'EACgAAXEdVNPAg==' },
  },
  {
    key: '[Misc]/Quest/Act 3/Complete Flail',
    value: {
      base64: 'ECCAAAUUZFNmwlPaCUXgAAQeGCagICNAgYfBh6GLkaz/AQ==',
    },
  },
  {
    key: '[Misc]/Quest/Act 3/Eye',
    value: {  base64: 'EACgAAXAdXNAJQ==' },
  },
  {
    key: '[Misc]/Quest/Act 3/Flail',
    value: {
      base64: 'EACAAAUQZFP+BCWx7vXq8Qc8NkxAQUZAQRcjWf8D',
    },
  },
  {
    key: '[Misc]/Quest/Act 3/Gidbinn',
    value: {
      base64: 'EACAAAWIZG23wXwu7316/D8PCWT9Dw==',
    },
  },
  {
    key: '[Misc]/Quest/Act 3/Gold Bird',
    value: {  base64: 'ECCgAAUIZG2/Eg==' },
  },
  {
    key: '[Misc]/Quest/Act 3/Heart',
    value: {  base64: 'EACgAAXIdROfBA==' },
  },
  {
    key: "[Misc]/Quest/Act 3/Lam Esen's Tome",
    value: {  base64: 'EACgAAUURFUT' },
  },
  {
    key: '[Misc]/Quest/Act 4/Hammer',
    value: {
      base64: 'EACAAAUQBMs4sLjq/mAPP3AD40MLTsCDUUCBrP8B',
    },
  },
  {
    key: '[Misc]/Quest/Act 4/Soul Stone',
    value: {  base64: 'ECCgAAXQxBIl' },
  },
  {
    key: "[Misc]/Quest/Act 5/Malah's Potion",
    value: {
      base64: 'ECCAAAXU5CeG8FLexe0UkPU/',
    },
  },
  {
    key: '[Misc]/Quest/Act 5/Scroll of Malah',
    value: {  base64: 'ECCgAAUQxBwmAQ==' },
  },
  {
    key: "[Misc]/Quest/Bugged Tal Rasha's",
    value: {
      base64:
        'EAiAAAXAFBocJAM5c8fFEzjRzY0IHzRDItwJeCngrYDXAh6Y1ohnC8of/U/j+Q8=',
    },
  },
  {
    key: '[Misc]/Quest/Essences & Token/Burning Essence of Terror(Red)',
    value: {  base64: 'ECCgAATARAcTAA==' },
  },
  {
    key: '[Misc]/Quest/Essences & Token/Charged Essence of Hatred(Yellow)',
    value: {  base64: 'ECCgAASARAw4AA==' },
  },
  {
    key: '[Misc]/Quest/Essences & Token/Festering Essence of Destruction(Green)',
    value: {  base64: 'ECCgAAQERB7GAA==' },
  },
  {
    key: '[Misc]/Quest/Essences & Token/Token of Absolution',
    value: {  base64: 'ECCgAAQAxPxfAA==' },
  },
  {
    key: '[Misc]/Quest/Essences & Token/Twisted Essence of Suffering(Blue)',
    value: {  base64: 'ECCgAARAxAwUAA==' },
  },
  {
    key: "[Misc]/Quest/Keys & Organs/Baal's Eye",
    value: {  base64: 'ECCgAARARAdUAA==' },
  },
  {
    key: '[Misc]/Quest/Keys & Organs/Destruction',
    value: {
      base64: 'EACAAAUIZErbkF+CMvAV/Ac=',
    },
  },
  {
    key: "[Misc]/Quest/Keys & Organs/Diablo's Horn",
    value: {  base64: 'ECCgAAQAZMRsAA==' },
  },
  {
    key: '[Misc]/Quest/Keys & Organs/Hate',
    value: {
      base64: 'EACAAAUIZEpMgNyN1YAK/gM=',
    },
  },
  {
    key: "[Misc]/Quest/Keys & Organs/Mephisto's Brain",
    value: {  base64: 'ECCgAASAxOoJ' },
  },
  {
    key: '[Misc]/Quest/Keys & Organs/Terror',
    value: {
      base64: 'EACAAAUMZEqfIHbSiCEV/Ac=',
    },
  },
  {
    key: '[Misc]/Quest/Standard of Heroes',
    value: {
      base64: 'EACAAAVMlswYAsxsSMfH//sP',
    },
  },
  {
    key: '[Misc]/Quest/Trap Suwayyah',
    value: {
      base64: 'ECiAAAQUxL8TAJCjbbRDwMAYXjAAW/Nw/wE=',
    },
  },
  */
  {
    key: '[Rares]/Amulet/Armageddon Fletch',
    value: {
      base64: 'ECCAAARY5FkYNE1GMLUWgFkAUyIAMmlQB64k2DrxLcW3Fd9afOOS+g8=',
    },
  },
  {
    key: '[Rares]/Amulet/Fiendra Sunder',
    value: {
      base64: 'ECCAAARk5FkY3BdqprQWcB0AUygAM2A8B7YkyBJA49L6Dw==',
    },
  },
  {
    key: '[Rares]/Amulet/Grim Necklace',
    value: {
      base64: 'ECCAAASk5FkYxLBoPLQWSg0BUyYAMQJmCa7sXOGNy/BEthTfWlz7Dw==',
    },
  },
  {
    key: '[Rares]/Amulet/Imp Brow',
    value: {
      base64: 'ECCAAATk5FkY3kcE1rQWboUAUygAMzwOPg5ToBPdUnRb0a1FNy6T/w==',
    },
  },
  {
    key: '[Rares]/Amulet/Order Noose',
    value: {
      base64: 'ECCAAAQc5FkY8pwUfrUWigsBUyAAMwJaCXJWYOMyPAEuhbcW3v4D',
    },
  },
  {
    key: '[Rares]/Ring/Beast Circle',
    value: {
      base64: 'ECCAAASc5PzYMMl4Za21wKkH4EHwcViRL8U0KINcJP8B',
    },
  },
  {
    key: '[Rares]/Ring/Bitter Turn',
    value: {
      base64: 'ECCAAATc5PzYAJX3EKi1INwH4FGYMIiAVopxAFq4uBKw/Ac=',
    },
  },
  {
    key: '[Rares]/Ring/Blood Whorl',
    value: {
      base64: 'ECCAAARc5PzYUCqIyqa1ICoI4GHwUVgx7oQ2KIRcGv8B',
    },
  },
  {
    key: '[Rares]/Ring/Bone Master',
    value: {
      base64: 'ECCAAAQA9PzYMIhelaS1YCoJSONJEHfiWoprK661uJaC3YiAi+s/',
    },
  },
  {
    key: '[Rares]/Ring/Corruption Grip',
    value: {
      base64: 'ECCAAATg5PzYIFl8R6u1kOwF4GGYUImPw4lrKa6tuNbi2gl3XFxPPP0H',
    },
  },
  {
    key: '[Rares]/Ring/Eagle Circle',
    value: {
      base64: 'ECCAAASg5PzYAI3cJ6u10KkH4FGYMISPw4lrKa6tuNbi2gp/XFz/AQ==',
    },
  },
  {
    key: '[Rares]/Ring/Shadow Spiral',
    value: {
      base64: 'ECCAAARg5PzY8OD90qq1gOoH4FEA4OLjkCIfFDguriz2Hw==',
    },
  },
  {
    key: '[Rares]/Ring/Viper Whorl',
    value: {
      base64: 'ECCAAAQg5PzYoLi/U6218CkI4GGYYMGBIyeupbi24lqLawmAuLh8HP4D',
    },
  },
  /*
  {
    key: '[Runes]/Amn Rune',
    value: {  base64: 'EACgAAQA5Hw+AQ==' },
  },
  {
    key: '[Runes]/Ber Rune',
    value: {  base64: 'EACgAAQE5Gy/Aw==' },
  },
  {
    key: '[Runes]/Cham Rune',
    value: {  base64: 'EACgAAQI5GyZAA==' },
  },
  {
    key: '[Runes]/Dol Rune',
    value: {  base64: 'EACgAAQM5Hy+Ag==' },
  },
  {
    key: '[Runes]/El Rune',
    value: {  base64: 'EACgAAQQ5Hx/Ag==' },
  },
  {
    key: '[Runes]/Eld Rune',
    value: {  base64: 'EACgAAQU5HwzAQ==' },
  },
  {
    key: '[Runes]/Eth Rune',
    value: {  base64: 'EACgAAQY5HyjBQ==' },
  },
  {
    key: '[Runes]/Fal Rune',
    value: {  base64: 'EACgAAQc5HxcAA==' },
  },
  {
    key: '[Runes]/Gul Rune',
    value: {  base64: 'EACgAARA5DBoAQ==' },
  },
  {
    key: '[Runes]/Hel Rune',
    value: {  base64: 'EACgAARE5HzQAg==' },
  },
  {
    key: '[Runes]/Io Rune',
    value: {  base64: 'ECCgAASA5Hz2AQ==' },
  },
  {
    key: '[Runes]/Ist Rune',
    value: {  base64: 'EACgAARI5DBfAQ==' },
  },
  {
    key: '[Runes]/Ith Rune',
    value: {  base64: 'EACgAARM5HzvAw==' },
  },
  {
    key: '[Runes]/Jah Rune',
    value: {  base64: 'EACgAARQ5Gw/AQ==' },
  },
  {
    key: '[Runes]/Ko Rune',
    value: {  base64: 'EACgAARU5HyQAA==' },
  },
  {
    key: '[Runes]/Lem Rune',
    value: {  base64: 'EACgAARY5DDfAQ==' },
  },
  {
    key: '[Runes]/Lo Rune',
    value: {  base64: 'EACgAARc5DBIAA==' },
  },
  {
    key: '[Runes]/Lum Rune',
    value: {  base64: 'EACgAASA5Hx8AA==' },
  },
  {
    key: '[Runes]/Mal Rune',
    value: {  base64: 'EACgAASE5DDbAA==' },
  },
  {
    key: '[Runes]/Nef Rune',
    value: {  base64: 'EACgAASI5Hx/BQ==' },
  },
  {
    key: '[Runes]/Ohm Rune',
    value: {  base64: 'EACgAASM5DA+' },
  },
  {
    key: '[Runes]/Ort Rune',
    value: {  base64: 'EACgAASQ5Hy7AA==' },
  },
  {
    key: '[Runes]/Po Rune',
    value: {  base64: 'EACgAASU5Hz2AQ==' },
  },
  {
    key: '[Runes]/Pul Rune',
    value: {  base64: 'EACgAASY5DCfAA==' },
  },
  {
    key: '[Runes]/Ral Rune',
    value: {  base64: 'EACgAASc5HwjAQ==' },
  },
  {
    key: '[Runes]/Shael Rune',
    value: {  base64: 'EACgAATA5Hy2AQ==' },
  },
  {
    key: '[Runes]/Sol Rune',
    value: {  base64: 'EACgAATE5HyYAA==' },
  },
  {
    key: '[Runes]/Sur Rune',
    value: {  base64: 'EACgAATI5DAu' },
  },
  {
    key: '[Runes]/Tal Rune',
    value: {  base64: 'EACgAATM5Hz7AA==' },
  },
  {
    key: '[Runes]/Thul Rune',
    value: {  base64: 'EACgAATQ5Hy+Aw==' },
  },
  {
    key: '[Runes]/Tir Rune',
    value: {  base64: 'EACgAATU5HxvAw==' },
  },
  {
    key: '[Runes]/Um Rune',
    value: {  base64: 'EACgAATY5DBMAA==' },
  },
  {
    key: '[Runes]/Vex Rune',
    value: {  base64: 'EACgAATc5DD7AA==' },
  },
  {
    key: '[Runes]/Zod Rune',
    value: {  base64: 'EACgAAQg5Gy3AQ==' },
  },
  */
  {
    key: '[Base]/Shield/Class-Items/Sacred Targe(AllRes)',
    value: {
      base64: 'EACAAAUgdD4Npu7CnlUxA1DR0uJEvRT1VtRrUe8/',
    },
  },
  {
    key: "[Magic]/Shield/Jeweler's Monarch of Deflecting",
    value: {
      base64: 'EAiAAAUABP5MSBdZqIUSpmkFT1ghIQqUGdl/',
    },
  },
]
